'use strict';

const {loadAtolWidgets} = require('components/atol_protected/js/main');
const {dispatch} = require('od-modules/secure_store/store');
const {SET_RESULTS_SELECTION} = require('od-modules/secure_store/actions');
const tripTypeUtils = require('../../modules/utils/trip_type');
const BaggageIncludedTracking = require('../../tracking/baggageincludedtracking');
const trackingUtils = require('../../modules/utils/tracking.utils');
const changeFlightFreeChargeUtils = require('../../modules/utils/flight_change_free');
const membershipBannerFactory = () => import(/* webpackChunkName: "membership-banner" */ 'components/membership/membership_banner/js/main');
const calculateFullPriceLegalDisplay = require('../../modules/calculators/full_price_legal_display');
const noResultsDialogDisplayer = require('../../modules/ui/no_results_dialog_displayer');
const priceUtils = require('../../modules/results/price.js');
const seatsUtils = require('../../modules/seats/utils');
const templatesUtils = require('./utils/templatesUtils');
const OdiRatingHeaderView = require('./odirating_header.view');
const SegmentItemView = require('./itinerary/segment_item.view');
const sortingTabsInjector = require('./sorting_tabs/view_injector');
const returningVisitTracking = require('../../modules/returning_visitors/tracking');
const currentSearchSingletonModel = require('../../modules/models/current_search.singleton.model');
const {hasRememberMeCookie} = require('od-modules/utils/sso.utils');
const {highlightedLayoutMap} = require('./utils/recommendedHighlightedItineraryLayoutMap');

const {getPrimePriceData: getPrimePriceDataDPCommon,
    getPriceDiscountData: getPriceDiscountDataDPCommon,
    getPriceFormat,
} = require('../../modules/parsers/dynpack_common');
var tagManagement = require('../../modules/utils/tag_management.utils');

const ODIRATING_TAG = 'ODIRATING';
const NONE_TAG = 'NONE';

var createCTATexts = function(data, itinerary, mainPrice, ctaPriceEnabled, isCtaTextEnabled) {
    var ctaTextEnabled = isCtaTextEnabled || !ctaPriceEnabled;
    var translations = data.translations;
    var selectFlight = Odigeo.Utils.pluralizeAll(translations.selectFlight, itinerary.numberOfSegments);
    return {
        text: ctaTextEnabled ? selectFlight : '',
        price: ctaPriceEnabled ? mainPrice : '',
    };
};

var priceCheckBox = {
    discountedPrice: '.itinerary_header input[type="radio"][value="true"]',
    standardPrice: '.itinerary_header input[type="radio"][value="false"]',
};
const isDynpack = Odigeo.Utils.isRequestApp('dp');
var continueBooking = function(data) {
    const {
        membershipPriceDisplayDesktop,
        membershipPriceDisplayMobile,
        isMembershipProductEnabledDesktop,
    } = Odigeo.Membership;
    const itineraryInfo = getItineraryInfo.call(this, data);
    let bookFlightData = getBookingData(itineraryInfo);
    let priceDiscountType = itineraryInfo.isPriceWithoutDiscountSelected ? 'nonmember' : 'member';
    const isMembershipPriceDisplayDesktopCondition = Odigeo._.includes(['SHOW_ALL_FARES', 'SHOW_ALL_FARES_NO_EXPAND', 'EXPANDABLE', 'FILTER_STICKY'],
        membershipPriceDisplayDesktop);
    const isNewPriceDisplay = (
        isMembershipPriceDisplayDesktopCondition ||
        membershipPriceDisplayMobile === 'FILTER' || isMembershipProductEnabledDesktop) &&
        !Odigeo._.isUndefined(data.button.data('membership-price-display-which-two-buttons'));
    this.disableBookButtons(data.button);
    if (isNewPriceDisplay && !isDynpack) {
        priceDiscountType = data.button.data('membership-price-display-which-two-buttons');
        Odigeo._.set(bookFlightData, 'isPriceWithoutDiscountSelected', priceDiscountType === 'nonmember');
    }
    let membershipTrackLabel = 'pre-select-info_submitted_' + priceDiscountType;
    const isUserClickShowAllFares = Odigeo.Session.get('userClickOnShowMoreFares') || false;
    if ((membershipPriceDisplayDesktop === 'SHOW_ALL_FARES')
        && !isUserClickShowAllFares && priceDiscountType === 'member') {
        membershipTrackLabel = `${ membershipTrackLabel }_dir`;
        Odigeo.Session.set('userClickOnShowMoreFares', false);
    }
    this.widget.trackMembership(membershipTrackLabel);
    this.onClickBookFlightButton(bookFlightData);
};
var getItineraryInfo = function(data) {
    var segmentPositions = this.getSelectedSegmentPositions(data.resultContainer);
    return {
        segmentPositions: segmentPositions,
        selectedItinerary: this.model.getItinerary(Odigeo._.head(segmentPositions)),
        selectedSegments: Odigeo._.map(segmentPositions, Odigeo._.bind(function(segmentPosition) {
            return this.model.getSegment(segmentPosition);
        }, this)),
        isPriceWithoutDiscountSelected: getPriceWithoutDiscountSelected.call(this, data.resultContainer),
        hasRefundableFareUpgrade: data.hasRefundableFareUpgrade,
        refundableFareUpgradePrice: data.refundableFareUpgradePrice,
        refundableFareUpgradeShown: data.refundableFareUpgradeShown,
        returningUserDeviceId: Odigeo._.get(this.model.get('data'), 'returningUserDeviceId'),
    };
};
var getBookingData = function(data) {
    return {
        searchID: data.selectedItinerary.fareItinerarySearchId,
        itineraryID: data.selectedItinerary.mainItineraryId,
        selectedSegments: data.selectedSegments,
        selectedItinerary: data.selectedItinerary,
        isPriceWithoutDiscountSelected: data.isPriceWithoutDiscountSelected,
        segmentPositions: data.segmentPositions,
        hasRefundableFareUpgrade: data.hasRefundableFareUpgrade,
        refundableFareUpgradePrice: data.refundableFareUpgradePrice,
        refundableFareUpgradeShown: data.refundableFareUpgradeShown,
        returningUserDeviceId: data.returningUserDeviceId,
        fareSelection: data.selectedItinerary.fareSelection,
    };
};
var shouldShowSlashedPrice = function(isSlashedPricePartition, diffBetweenSlashedAndNormalPrice) {
    return isSlashedPricePartition && parseFloat(diffBetweenSlashedAndNormalPrice) !== 0;
};
var buildPriceClass = function(price, classesCollection, prop) {
    var classes = classesCollection[prop];
    if (Odigeo._.isFunction(classes)) {
        return classes(price);
    } else if (Odigeo._.isEmpty(classes)) {
        return classesCollection.generic || '';
    }
    return classes;
};
var buildPriceClasses = function(price, classesCollection) {
    classesCollection = classesCollection || {};
    var props = [
        'generic',
        'prefix',
        'integer',
        'decimalSeparator',
        'decimal',
        'suffix',
        'asterisk',
    ];
    var classesPerType = Odigeo._.reduce(props, function(classesPerType, prop) {
        classesPerType[prop] = buildPriceClass(price, classesCollection, prop);
        return classesPerType;
    }, {});
    classesPerType.container = classesCollection.container;
    return classesPerType;
};
var buildPriceObj = function(priceConfig, classes, currency) {
    var currencyInfo = Odigeo._.extend({}, Odigeo.Utils.Currency, currency, {decimalPlaces: 2});
    var splittedPrice = Odigeo.Utils.splitFormatedCurrency(priceConfig.price, currencyInfo);
    var decimal = splittedPrice.decimal.replace(currencyInfo.decimalSeparator, '');
    var price = Odigeo._.extend({
        showPriceDecimals: priceConfig.showPriceDecimals,
    }, splittedPrice, currencyInfo, {
        decimal: decimal,
        showAsterisk: priceConfig.showAsterisk,
    });
    return {
        price: price,
        classes: buildPriceClasses(price, classes),
    };
};
var saveMinSeatsLeft = function(selectedSegments, selectedItinerary) {
    var seats = Odigeo._.map(selectedSegments, function(selectedSegment) {
        return Odigeo._.isUndefined(selectedSegment) ? null : Odigeo._.parseInt(selectedSegment.numSeatsLeft);
    });
    var seatsLeftPerFlight = Odigeo._.min(seats);
    var segmentChosen = (Odigeo._.isNull(seats) || seats.length === 1) ? '2' : Odigeo._.indexOf(seats, seatsLeftPerFlight);
    var seatsLeftValue = !Odigeo._.isNull(seats) ? selectedItinerary.numSeatsLeft : seatsLeftPerFlight;
    if (Odigeo._.isFinite(seatsLeftValue)) {
        Odigeo.Utils.createCookie('minSeatsLeft', encodeURIComponent(seatsLeftValue + '-' + segmentChosen));
    } else {
        Odigeo.Utils.eraseCookie('minSeatsLeft');
    }
};

const buildMultipleLogos = function(icons, templates, carrierName, multipleAirlinesText) {
    const logosNumberLimit = 2;
    const iconsList = icons || [];
    const uniqueCarrierLogos = iconsList.filter((icon, index) => iconsList.indexOf(icon) === index);
    const visibleCarrierLogos = uniqueCarrierLogos.slice(0, logosNumberLimit);
    let logos = '';
    let airlineText = '';
    if (uniqueCarrierLogos.length) {
        airlineText = (uniqueCarrierLogos.length === 1) ? carrierName : multipleAirlinesText;
        if (uniqueCarrierLogos.length > logosNumberLimit) {
            logos = templatesUtils.template(templates.singleLogo)({logo: Odigeo.Utils.getImageFromCDN(`onefront/airlines/smVIN2.gif`)});
        } else {
            logos = visibleCarrierLogos.reduce((list, logo) => list + templatesUtils.template(templates.singleLogo)({logo}), '');
        }
    }
    return {logos, airlineText};
};

const recommendedTagsType = function(type) {
    const recommendedTags = {odirating: 'o', cheapest: 'c', fast: 'f', baggage: 'b', none: '0'};
    if (type && recommendedTags[type.toLowerCase()]) {
        return recommendedTags[type.toLowerCase()];
    }
};

const getPriceWithoutDiscountSelected = function($container) {
    return Odigeo.Membership.isPrimeUkResultsBoxMobile ?
        this.model.get('isPriceWithoutDiscountSelected') :
        $container.data('is-price-without-discount-selected');
};

module.exports = {
    isOdiRatingSelected: Odigeo._.noop,
    checkIsFareUpgradeAvailable: Odigeo._.noop,
    setIsFareUpgradeAvailable: Odigeo._.noop,
    togglePaymentMethodFooter: () => undefined,
    toggleAppTouchpoint: () => undefined,
    toggleFreeCancellationResults: () => undefined,
    toggleSortingTabs: () => undefined,
    blockSortingTabs: () => undefined,
    listenFareUpgrades: Odigeo._.noop,
    setFixedPrimeBannerForKnowMore: Odigeo._.noop,
    getSecondaryMessage: () => '',
    _numAddedResults: 0,

    _templates: null,

    selectors: {
        resultsPageContainer: '.resultspage_section',
        resultsContainer: '.inner_results_container',
        resultsDisabler: '.results_disabler',
        resultsLoader: '.results_loader',
        backToTopBtn: '.back_to_top_btn',
        resultsCreditCardContainer: '.results_creditcard_container',
        resetFilter: '.reset_filter',
        numberOfResults: '.number_of_results',
        numFilteredResults: '.num_filtered_results',
        filteredResultsMsg: '.filtered_results_msg',
        totalResultsMsg: '.total_results_msg',
        appTouchpointBottom: '#app-touchpoint-resultsbottom',
        resultsTranslations: '.results_translations',
        results_disclaimer: '.disclaimer_wrapper',
        resultsDisclaimerDiv: '#results_disclaimer_div',
        bookingRatingPopup: '.user_identification_template_login',
        resultBoxes: '.result',
        resultWrappers: '.result_wrapper',
        dpPreselected: '#accommodationsuggested-manager-flights .dp_preselected',
        showFaresDiscovery: '.show_fares_discovery',
        showAllFaresTooltip: '.show_all_fares_tooltip',
        closePrimeFooterPopup: '.close_prime_footer_popup',
        primeLogoPriceAtFooter: '.prime_logo_price_at_footer',
    },

    events: {
        'change .is_price_without_discount_radio': 'changePriceDiscountRadio',
        'tap .price_box': 'changeActivePrice',
        'tap .membership_know_more_expanded': 'openMembershipPerksInfoLightbox',
        'tap .membership_show_subscription_info': 'openMembershipPerksInfoLightbox',
        'tap .results_fare_upgrade_terms': 'clickFareUpgradeTerms',
        'tap @showFaresDiscovery': 'onShowFaresDiscovery',
        'mouseover @showAllFaresTooltip': 'onToggleFaresTooltip',
        'mouseout @showAllFaresTooltip': 'onToggleFaresTooltip',
        'click @closePrimeFooterPopup': 'onClosePrimeFooterPopup',
        'click @primeLogoPriceAtFooter': 'onClickPrimeLogoAtFooter',
    },

    init() {
        this.cacheDomSelectors();
        this.bindToDom();
        this._bindResults();
        this.createAppTouchpoint('resultsbottom', 'app_download_bottom');
        var tripType = currentSearchSingletonModel.getInstance().get('type');

        this._templates = this._extractTemplates();
        Odigeo._.extend(this._templates, Odigeo.Utils.getTemplates($('.global_templates'), {
            panel: '.fare_upgrade_panel_template',
        }));
        Odigeo.trigger(this.widget.id + ':requestFiltersButtonMeasures');

        if (this.widget.options.isDynpack) {
            this.$widget.find('.creditCardSelector').trigger('hideExpandable');
        }
        if (!Odigeo.AB.isFareUpgradeRenderable || Odigeo.AB.isFareUpgradePaxRenderable) {
            this.listenFareUpgrades();
        }
        if (Odigeo.AB.isMembershipMoreExplanationFixingBanner) {
            this.setFixedPrimeBannerForKnowMore();
        }

        if (this.widget.options.tests.sortingTabsEnabled && !tripTypeUtils.isMultipleDestinations(tripType)) {
            sortingTabsInjector(this).create('sortingTabs');
        }

        if (Odigeo.AB.isFloatingFiltersEnabled) {
            this.floatingElementOnScroll(this.unfixedFloatingButtonIfGetToBottom);
        }
    },
    createAppTouchpoint: Odigeo._.noop,

    floatingElementOnScroll(fn) {
        $(window).on('scroll', Odigeo._.bind(fn, this));
    },

    unfixedFloatingButtonIfGetToBottom() {
        const floatingFilterButtonAreaHeight = 164;
        const $floatingButton = $('.floating_filter_btn');
        const $window = $(window);
        const $resultsContainer = this.$cachedSelectors.resultsContainer;
        const stickerMax = $('.results_area').outerHeight() + $resultsContainer.offset().top;
        const windowBottomPos = $window.scrollTop() + $window.height();
        $floatingButton.toggleClass('unfixed', windowBottomPos - floatingFilterButtonAreaHeight > stickerMax);
    },

    cacheDomSelectors() {
        var creditCardSelectorElems = this.$widget.find('.creditCardSelector');
        Odigeo.trigger(this.widget.id + ':initCacheDomSelectors');

        this.$cachedSelectors.resultsContainer.data('loader', this.widget.options.show_loading_more === 'true');
        this.$cachedSelectors.resultsContainer.data('autoupdate', true);
        this.$cachedSelectors.resultsContainer.data('bouncing', true);
        this.$cachedSelectors.resultsContainer.data('loading-message', this.widget.options.loading_message);
        Odigeo.trigger(this.widget.id + ':toggleLoader', true);

        this.addSelectorToCache('resultsContainerScrollable', this.$cachedSelectors.resultsContainer.find('.results_area'));

        if (creditCardSelectorElems.length > 0) {
            Odigeo.UIElements.enhanceExpandable(creditCardSelectorElems);
        }

        const {membershipPriceDisplayMobile} = Odigeo.Membership;
        const isMembershipPriceFilter = membershipPriceDisplayMobile === 'FILTER';
        if (isMembershipPriceFilter && Odigeo.SessionScope.flowProduct !== 'dp') {
            const primeFilterSelector = this.$widget.find('.prime_filter_selector');
            Odigeo.UIElements.enhanceExpandable(primeFilterSelector);
        }

        this.addSelectorToCache('creditCardSelector', this.$widget.find('.credit_card_selector'));
        this.addSelectorToCache('waitingPage', $('.waiting_page'));

        Odigeo.trigger(this.widget.id + ':enhancePagination');
    },
    createFareUpgradePanelView: Odigeo._.noop,

    template: templatesUtils.template,

    hideWaitingPage() {
        Odigeo.UIElements.enhanceLoading(this.$cachedSelectors.waitingPage).hideLoading();
    },

    showNoResultsScreen(options) {
        noResultsDialogDisplayer.showNoResultsScreen(options);
    },

    showNoFilteredResultsScreen(options) {
        noResultsDialogDisplayer.showNoFilteredResultsScreen(options);
    },

    bindToDom() {
        var widget = this.widget;
        if (!this.isDomBinded) {
            this.$cachedSelectors.resultsContainer.on('slideLeft', function() {
                Odigeo.trigger('results:slideLeft');
            });

            switch (this.widget.options.paginationType) {
                case 'blockPagesSet':
                case 'nPagesSet':
                    break;
                case 'loadMore':
                    this.$cachedSelectors.resultsContainer.on('reachedstart', Odigeo._.bind(this.loadResultsHandler, this));
                    this.$cachedSelectors.backToTopBtn.on(Odigeo.Events.tap, Odigeo._.bind(this._backToTop, this));
                    break;
                default:
                    this.$cachedSelectors.resultsContainer.on('reachedstart', Odigeo._.bind(this.loadResultsHandler, this));
                    this.$cachedSelectors.resultsContainer.on('scrollend', Odigeo._.bind(this._scrollHandler, this));
                    this.$cachedSelectors.backToTopBtn.on(Odigeo.Events.tap, Odigeo._.bind(this._backToTop, this));
            }
            this.$cachedSelectors.resetFilter.on(Odigeo.Events.tap, Odigeo._.bind(this.resetFiltersHandler, this));

            Odigeo.bind('loadResults', Odigeo._.bind(widget.searchFlightsHandler, widget));
            this.isDomBinded = true;
            this.$cachedSelectors.creditCardSelector.on('change', Odigeo._.bind(this.changeCreditCardSelection, this));
        }
    },

    unbindFromDom() {
        if (this.isDomBinded) {
            this.$cachedSelectors.resultsContainer.off('slideLeft');
            this.$cachedSelectors.resultsContainer.off('scrollend');
            this.$cachedSelectors.resultsContainer.off('reachedstart');
            this.$cachedSelectors.resultsMoreButton.off(Odigeo.Events.tap);
            this.$cachedSelectors.resetFilter.off(Odigeo.Events.tap);
            this.$cachedSelectors.backToTopBtn.off(Odigeo.Events.tap);
            Odigeo.unbind('loadResults');

            this.isDomBinded = false;
        }
    },

    changeActivePrice(e) {
        var isDiscountSelected = !$(e.currentTarget).data().value;
        this.trackMembershipPriceSelected(isDiscountSelected);
        $(e.currentTarget).parent().find('.price_box.active').removeClass('active');
        $(e.currentTarget).addClass('active');
        this.changePriceDiscountSelected($(e.target).parents('.result'), isDiscountSelected);
    },

    resetFiltersHandler() {
        trackingUtils.trackEventWithCategory(
            'flights_results',
            'results_filters',
            'undo_filtering_results'
        );
        Odigeo.trigger(this.widget.id + ':resetFiltersClicked');
    },

    changeCreditCardSelection() {
        this.$cachedSelectors.resultsLoader.removeClass('hidden');
        var ccId = this.$cachedSelectors.creditCardSelector.val();
        Odigeo.trigger(this.widget.id + ':paymentMethodFilterChanged',
            [
                {
                    'id': ccId,
                    'numBaggage': -1,
                },
            ]);
    },

    _scrollHandler(e, data) {
        var widget = this.widget;
        this.$cachedSelectors.backToTopBtn.toggleClass('hidden', (data.top < widget.BACK_TO_TOP_THRESHOLD));
    },

    _backToTop() {
        Odigeo.trigger(this.widget.id + ':backToTop', {
            top: 0,
            left: 0,
            duration: 500,
        });
        this.$cachedSelectors.backToTopBtn.addClass('hidden');
        this.widget.backToTop = true;
    },

    _updateHeigth() {
        Odigeo.trigger(this.widget.id + ':heightChanged', '.inner_results_container');
    },

    _bindResults() {
        var _isLastToCheck = function($itineraryGroups, isNativeInput) {
            var allOnlyChild = true;
            var toCheck = [];
            var toActive = [];
            var $checkbox;
            var $row;

            $itineraryGroups.each(function(i, group) {
                $row = $('.itinerary_row', group);
                if ($row.length === 1) {
                    $checkbox = $('.radio:not(.checked)', group);
                    if ($checkbox.length === 1) {
                        toCheck.push($checkbox);
                        toActive.push($row);
                    }
                } else if ($('.checked', group).length === 0) {
                    allOnlyChild = false;
                }
            });

            if (allOnlyChild && toCheck.length > 0) {
                $.map(toCheck, function(e, i) {
                    e.addClass('checked');
                    if (isNativeInput) {
                        $(e).prop('checked', true);
                    }
                    toActive[i].addClass('active-row');
                });
            }
        };

        var _hasItineraryHighlighted = function(itineraryId) {
            var validFlow;
            var validation = {};

            validFlow = Odigeo._.find([{
                funnel: 'dynpack',
                itineraryId: $(this.selectors.dpPreselected).data('fareItineraryId'),
            }], {funnel: Odigeo.Utils.getFunnelInGlobalScope()});
            validation.isValidFlow = !Odigeo._.isUndefined(validFlow);
            validation.isValidItinerary = validation.isValidFlow && !Odigeo._.isNull(validFlow.itineraryId) && validFlow.itineraryId === itineraryId;

            return validation;
        };

        var _checkBoxHandler = function(e) {
            e.preventDefault();
            var $resultGroup = $(e.target).closest('.result');
            var $itineraryGroup = $(e.target).closest('.itinerary_group');
            var $itineraryRow = $(e.target).closest('.itinerary_row');
            var $itineraryRows = $('.itinerary_row', $itineraryGroup);
            var $itineraryRowOther = $itineraryRows.not($itineraryRow);
            var fareItineraryId = $resultGroup.data('fareItineraryId');
            var itineraryHighlighted = _hasItineraryHighlighted.call(this, fareItineraryId);

            if (!$itineraryRow.hasClass('active-row')) {
                selectSegment.call(this, {
                    $resultGroup,
                    $itineraryGroup,
                    $itineraryRow,
                    $itineraryRows,
                    $itineraryRowOther,
                    fareItineraryId,
                    itineraryHighlighted,
                });
            } else {
                this.checkBeforeDeselect($itineraryRow, $itineraryRowOther);
            }

            if (itineraryHighlighted.isValidFlow && !itineraryHighlighted.isValidItinerary) {
                Odigeo.trigger(this.widget.id + ':highlightPreselected', {isChangedItinerary: true});
            }

            this._updateHeigth();
        };

        var selectSegment = function(locatorsData) {
            var $itineraryGroups = $('.itinerary_group', locatorsData.$resultGroup);
            var $itineraryGroupsOthers = $itineraryGroups.not(locatorsData.$itineraryGroup);
            var $itineraryRowsOtherGroups = $('.itinerary_row', $itineraryGroupsOthers);
            var $resultGroupsOthers = this.$el.find('.result').not(locatorsData.$resultGroup);
            var $itineraryRowsAll = $resultGroupsOthers.find('.itinerary_row');
            var $bookBtn = $('.book_btn_container', locatorsData.$resultGroup);
            var $allInputsGroup;

            locatorsData.$itineraryRow.addClass('active-row');

            // We have to discretize when we have a native input or a div acting as a input
            if (this.widget.isNativeInput) {
                var $notVisibleItineraryRows = $itineraryRowsAll.not($itineraryRowsOtherGroups).filter(function() {
                    return $(this).css('display') === 'none';
                });

                locatorsData.$itineraryRow.find('input').prop('checked', true).addClass('checked');
                locatorsData.$itineraryRowOther.removeClass('active-row').find('input').prop('checked', false).removeClass('checked');
                locatorsData.$resultGroup.find(this.$cachedSelectors.bookingError.trigger('collapsePanel'));
                this.widget.view.resetItinerarySelectedUIState($resultGroupsOthers, $notVisibleItineraryRows);
            } else {
                $('.radio', locatorsData.$itineraryRow).addClass('checked');
                $itineraryRowsAll.removeClass('active-row hidden').find('.radio.checked').removeClass('checked');
                Odigeo.trigger(
                    this.widget.id + ':selectItinerary',
                    {$itineraryContainer: locatorsData.$resultGroup},
                );

                if (locatorsData.$itineraryRows.length > 1) {
                    this.hideItineraryRows(locatorsData.$itineraryRowOther);
                }
            }

            $('.result_details_btn.expanded', locatorsData.$itineraryGroup).each(function() {
                this.widget._detailsHandler(locatorsData.e);
            });

            _isLastToCheck($itineraryGroups, this.widget.isNativeInput);

            if (locatorsData.itineraryHighlighted.isValidItinerary && locatorsData.$itineraryRows.length > 1) {
                var segmentGroups = ['outboundFlight', 'returnFlight'];
                var segmentNumbers = $itineraryGroups.find('.active-row').map(function() {
                    return $(this).data('flightNumber');
                }).get();
                var segmentSelected = segmentGroups[locatorsData.$itineraryGroup.data('itineraryGroupId') - 1];
                var segmentSelectedFligt = locatorsData.$itineraryRow.data('flightNumber');
                var fareItinerary = {};
                $bookBtn.find('.book_btn').removeClass('disabled');
                fareItinerary.id = locatorsData.fareItineraryId;
                fareItinerary[segmentSelected] = segmentSelectedFligt;
                fareItinerary[Odigeo._.without(segmentGroups, segmentSelected)[0]] = Odigeo._.without(segmentNumbers, segmentSelectedFligt)[0];
                Odigeo.trigger(this.widget.id + ':highlightPreselected', {fareItinerary: fareItinerary});
            }

            $allInputsGroup = $('.checked', $itineraryGroups);

            if ($allInputsGroup.length === $itineraryGroups.length) {
                locatorsData.$resultGroup.find('.book_flight_error').addClass('odf-hidden');
            }
        };

        var radioPriceSelectorHandler = function(event) {
            var $el = $(event.target);
            var $radioElement = $el.parent().parent().find('.is_price_without_discount_radio');
            $radioElement.prop('checked', true);
            $radioElement.trigger('change');
        };

        var bookFlightHandler = function(e) {
            const data = this.getFlightData.call(this, e.target, '.book_btn');

            this.processSelection(data.resultContainer);

            if (this.isSelectedItineraryValid(data.resultContainer)) {
                dispatch({type: SET_RESULTS_SELECTION, entry: true});
                this.processSelectedItineraryRows(data);
            } else {
                this.selectedItineraryError(data.resultContainer);
            }
        };

        this.$cachedSelectors.resultsContainer
            .on(Odigeo.Events.tap, '.sp_container', Odigeo._.bind(_checkBoxHandler, this))
            .on(Odigeo.Events.tap, '.price_label', Odigeo._.bind(radioPriceSelectorHandler, this))
            .on(Odigeo.Events.tap, '.result:not(.selected) .book_btn_container:not(.disabled)', Odigeo._.bind(bookFlightHandler, this))
            .on(Odigeo.Events.tap, '.result:not(.selected) .book_btn_container_prime:not(.disabled)', Odigeo._.bind(bookFlightHandler, this))
            .on(Odigeo.Events.tap, '.result:not(.selected) .book_btn_container_no_prime:not(.disabled)', Odigeo._.bind(bookFlightHandler, this));

        if (this.widget.options.tests.newResultCardEnabled && !Odigeo.Membership.isPrimeUkResultsBoxMobile) {
            this.$cachedSelectors.resultsContainer.on(Odigeo.Events.tap, '.result', Odigeo._.bind(this.onBookInfoButton, this));
        } else if (Odigeo.Membership.isPrimeUkResultsBoxMobile) {
            this.$cachedSelectors.resultsContainer.on(Odigeo.Events.tap, '.prime_fare_container', Odigeo._.bind(this.onBookInfoButton, this));
            this.$cachedSelectors.resultsContainer.on(Odigeo.Events.tap, '.full_fare_container', Odigeo._.bind(this.onBookInfoButton, this));
        }
    },

    getFlightData(target, selector) {
        var $button = $(target).closest(selector);
        var $resultContainer = (this.widget.options.tests.newResultCardEnabled) ? $(target).closest('.result') : $button.parents('.result');
        var data = {
            button: $button,
            resultContainer: $resultContainer,
            itineraryGroups: $resultContainer.find('.itinerary_group'),
            hasRefundableFareUpgrade: $button.data('refundable-fare-upgrade') || false,
            refundableFareUpgradePrice: $button.data('refundable-fare-upgrade-price'),
            refundableFareUpgradeShown: $button.hasClass('od_book_with_fare_btn'),
            precalculatedRefundableFareUpgradePrice: $button.data('precalculated-refundable-price'),
        };

        this.checkDefaultItineraryRows(data.itineraryGroups, $resultContainer);

        return Odigeo._.extend(data, {
            activeItineraryRows: this.getActiveItineraryRows(data.itineraryGroups, data.resultContainer),
        });
    },

    selectedItineraryError($resultContainer) {
        var $itineraryGroups = $resultContainer.find('.itinerary_group');
        if (!this.hasActiveItineraryRows($itineraryGroups, $resultContainer)) {
            this.bookFlightHandlerError($resultContainer, $itineraryGroups);
        }
    },

    processSelection($resultContainer) {
        const $otherResults = $resultContainer.closest(this.selectors.resultWrappers).siblings();
        var $itineraryGroups = $resultContainer.find('.itinerary_group');
        var $notVisibleItineraryRows = this.$el.find('.itinerary_row').not(':visible');
        this.widget.view.resetItinerarySelectedUIState($otherResults, $notVisibleItineraryRows);
        this.checkDefaultItineraryRows($itineraryGroups, $resultContainer);
    },

    isSelectedItineraryValid($resultContainer) {
        var $itineraryGroups = $resultContainer.find('.itinerary_group');
        return this.hasActiveItineraryRows($itineraryGroups, $resultContainer);
    },

    processSelectedItineraryRows(data) {
        const {membershipPriceDisplayDesktop} = Odigeo.Membership;
        if (membershipPriceDisplayDesktop === 'EXPANDABLE' && !this.widget.options.isEqualProminenceMetaV2 &&
            !isDynpack && !this.isItineraryExpanded(data.resultContainer) && !this.widget.model.get('isMembershipPriceDisplay')) {
            this.expandItinerary(data.resultContainer);
        } else {
            continueBooking.call(this, {
                resultContainer: data.resultContainer,
                button: data.button,
                hasRefundableFareUpgrade: data.hasRefundableFareUpgrade,
                refundableFareUpgradePrice: data.refundableFareUpgradePrice || data.precalculatedRefundableFareUpgradePrice,
                refundableFareUpgradeShown: data.refundableFareUpgradeShown,
            }, 'CTA');
        }
    },

    selectedPriceHandlerError($resultContainer) {
        $resultContainer.find(priceCheckBox.discountedPrice).parent().addClass('error');
        $resultContainer.find(priceCheckBox.standardPrice).parent().addClass('error');
    },

    expandItinerary($resultContainer) {
        $resultContainer.find('.itinerary_footer').addClass('odf-hidden');
        $resultContainer.find('.prime_logo_fee_right').addClass('od-invisible');
        $resultContainer.find('.membership_expanded_price').slideDown('swing');
        trackingUtils.trackEvent('results_list', 'select_result_open_fares');
    },

    isItineraryExpanded($resultContainer) {
        return $resultContainer.find('.itinerary_footer').hasClass('odf-hidden');
    },

    bookFlightHandlerError($resultContainer, $itineraryGroups) {
        var analyticsLabel = 'select_one_way_error';
        var $errorContainer = $resultContainer.find('.book_flight_error');

        if ($itineraryGroups.length === 2) {
            analyticsLabel = 'select_return_error';
        } else if ($itineraryGroups.length > 2) {
            analyticsLabel = 'select_multiple_destinations_error';
        }

        trackingUtils.trackEventWithCategory('flights_results', 'results_list', analyticsLabel);

        $resultContainer.find(this.$cachedSelectors.bookingError).trigger('expandPanel');
        if (!this.widget.options.tests.newResultCardEnabled) {
            Odigeo.Utils.scrollToElement($resultContainer);
        }
        $errorContainer
            .removeClass('odf-hidden')
            .find('.book_flight_error_msg')
            .addClass('fade in');
    },
    deselectItineraryRow($itineraryRow, $itineraryRowOther) {
        $('.radio', $itineraryRow).removeClass('checked');
        $itineraryRow.removeClass('active-row hidden');
        $itineraryRowOther.removeClass('active-row hidden');
    },
    bookFlight(bookingData) {
        var baggageIncludedTracking = new BaggageIncludedTracking(this.widget.options.baggageAllowanceTracking);
        var flights = [];
        var checkedSegments = [];
        var flightNumbers = [];
        var slowFlightSelected = false;
        var isLongHaul = false;
        var data;

        Odigeo.trigger('reloadPage:details');

        Odigeo._.each(bookingData.selectedSegments, Odigeo._.bind(function(segment) {
            if (this.widget.options.tests.oneSegmentPerLegEnabled) {
                checkedSegments.push(segment.indexWithinItineraryGroup);
            } else {
                checkedSegments.push(segment.iterCountIndex);
            }
            flights.push(this.widget.parseSelectedFlightInfo(segment));
            slowFlightSelected = slowFlightSelected || segment.isSlowFlight;
            flightNumbers.push(segment.flightNumbers);
            isLongHaul = segment.isLongHaul === 'true' || isLongHaul;
        }, this));

        data = {
            'fareItineraryKey': bookingData.itineraryID,
            'price': bookingData.selectedItinerary.price,
            'segmentKeys': checkedSegments,
            'searchId': bookingData.searchID,
            'flightNumbers': flightNumbers,
            'priceWithoutDiscountSelected': bookingData.isPriceWithoutDiscountSelected,
            'promotedItineraryTypes': this.getPromotedItineraryTypes(bookingData),
            'refundableFareUpgrade': bookingData.hasRefundableFareUpgrade,
            'refundableFareUpgradePrice': bookingData.refundableFareUpgradePrice,
            'refundableFareUpgradeShown': bookingData.refundableFareUpgradeShown,
            'externalSelectionRequest': bookingData.externalSelectionRequest,
            'carrierName': Odigeo._.get(bookingData, 'selectedItinerary.itineraryGroupsList[0].carrierName'),
        };

        if (bookingData.fareSelection) {
            data.fareSelection = bookingData.fareSelection;
        }

        if (
            (Odigeo.AB.isEqualProminenceMeta || this.widget.options.isEqualProminenceMetaV2) &&
            Odigeo.SessionScope.isMetaFlights &&
            Odigeo.SessionScope.isMeta &&
            Odigeo.SessionScope.flow === 'desktop'
        ) {
            const subscriptionType = !data.priceWithoutDiscountSelected
                ? `"prime"`
                : `"standard"`;
            Odigeo.Session.set('subscriptionSelectedOnContinue', subscriptionType);
        }

        if (
            (Odigeo.AB.isEqualProminenceMeta || this.widget.options.isEqualProminenceMetaV2) &&
            Odigeo.SessionScope.isMeta
        ) {
            const subscriptionType = !data.priceWithoutDiscountSelected
                ? 'prime'
                : 'standard';
            const selectedFare = subscriptionType === 'prime' ? 'with': 'without';
            const priceSelected = subscriptionType === 'prime' ?
                bookingData.selectedItinerary.pricePerPassenger :
                Math.abs(bookingData.selectedItinerary.membershipSlashedPrice/bookingData.selectedItinerary.numPassengers);
            trackingUtils.trackEventWithCategory(
                'flights_results',
                `prime_price_meta`,
                `prime_price_meta-click:${selectedFare}_prime-${priceSelected}:choice_widget-pag:flights_results`
            );
        }

        Odigeo._.extend(data, {'upsellTouchpointClicked': bookingData.upsellTouchpointClicked});
        this.model.setBookedFlights(flights);
        const selectedCarriers = flights.map(({carriercode}) => {
            return {carriercode};
        });
        Odigeo.Session.set('stayDetails', JSON.stringify({
            days: this.model.calculateStayDays(flights),
            isOneWay: flights.length === 1,
        }));
        Odigeo.Session.set('destinationSelected', flights[0].arrival);
        Odigeo.Session.set('selectedCarriers', JSON.stringify(selectedCarriers));

        saveMinSeatsLeft(bookingData.selectedSegments, bookingData.selectedItinerary, this.widget.options.tests);

        if (Odigeo.AB.isBetterDetailsWrapActive) {
            const highlightedTag = bookingData.selectedItinerary.odiRating.highlightedTag
                && recommendedTagsType(bookingData.selectedItinerary.odiRating.highlightedTag) || '0';
            this.widget.resultsTracking.trackOnSelectInSummary({
                positions: bookingData.segmentPositions,
                highlightedTag,
            });
        } else {
            this.widget.resultsTracking.trackOnSelect({
                positions: bookingData.segmentPositions,
                isPriceWithoutDiscountSelected: bookingData.isPriceWithoutDiscountSelected,
                isUserLogged: hasRememberMeCookie(),
            });
        }

        Odigeo.trigger(this.widget.id + ':bookFlight', {
            data: data,
            flightNumbers: flightNumbers,
        });

        const isFirstSearch = Odigeo.Session.get('isFirstSearch');
        Odigeo.Session.set('isFirstSearch', !isFirstSearch);

        baggageIncludedTracking.triggerEventTracking();

        Odigeo.Session.set('isVinFlight', Odigeo.Utils.isVinFlight(bookingData.selectedItinerary.fareItineraryType));
    },

    disableBookButtons($button) {
        var disabledClass = (Odigeo.AB.isFareUpgradeRenderable || Odigeo.AB.isFareUpgradePaxRenderable) ? 'loading' : 'disabled';
        $button.addClass(disabledClass);
        var buttonContainer = $button.closest('.book_btn_container');
        var $containerBookBtnList = this.$el.find('.book_btn_container');

        $button.addClass('disabled');
        $containerBookBtnList.not(buttonContainer).find('.book_btn').removeClass('disabled loading');
    },

    getSegmentRelativePositions($segment, $itinerary) {
        const $leg = $segment.closest('.itinerary_group');
        if (!$itinerary) {
            $itinerary = $leg.closest('.result');
        }
        var positions = {
            itinerary: this.getItineraryPosition($itinerary),
            leg: Odigeo._.parseInt($leg.data('itinerary-group-id')) - 1,
            segment: Odigeo._.parseInt($segment.data('itinerary-id')),
        };
        return Odigeo._.every(positions, Odigeo._.isFinite) && positions;
    },
    getItineraryPosition($result) {
        return Odigeo._.parseInt($result.data('relative-position'));
    },
    getSelectedSegmentPositions($itinerary) {
        return Odigeo._.map($itinerary.find('.itinerary_row.active-row'), Odigeo._.bind(function(segment) {
            return this.getSegmentRelativePositions($(segment), $itinerary);
        }, this));
    },
    openMembershipPerksInfoLightbox() {
        Odigeo.trigger(this.widget.id + ':openMembershipPerksInfoLightbox');
    },
    evaluateShowMembershipSubscriptionInfo(itemIndex, isMembershipDualPriceAbActive, data) {
        const hasMetaBox = Odigeo.SessionScope.isMetaFlights && this.model.landingToResultsFromMeta(data);
        return !hasMetaBox && (this.showMembershipSubscriptionInfoDualPrice(itemIndex, isMembershipDualPriceAbActive) ||
            this.showMembershipSubscriptionInfoRevamp(itemIndex));
    },
    showMembershipSubscriptionInfoRevamp(itemIndex) {
        const {isMembershipProductEnabledDesktop} = Odigeo.Membership;
        return isMembershipProductEnabledDesktop &&
            (itemIndex === 1 || itemIndex === 3);
    },
    showMembershipSubscriptionInfoDualPrice(itemIndex, isMembershipDualPriceAbActive) {
        return itemIndex === 1 && isMembershipDualPriceAbActive;
    },
    trackMoreClickedLink() {
        this.widget.trackMembership('know_more_clicked', true);
    },
    clickFareUpgradeTerms() {
        this.widget.fareUpgradeTracking.trackOnClickFareUpgradeTermsAndConditions({category: 'results_list'});
    },
    getActiveItineraryRows($resultContainer) {
        return $resultContainer.find('.itinerary_row.active-row');
    },

    checkDefaultItineraryRows($itineraryGroups, $resultContainer) {
        var $itineraryRow = $resultContainer.find('.itinerary_row');

        if ($itineraryGroups.length === $itineraryRow.length) {
            $itineraryRow.addClass('active-row');
            if (this.widget.isNativeInput) {
                $itineraryRow.find('input').prop('checked', true).addClass('checked');
            }
        }
    },

    hasActiveItineraryRows($itineraryGroups, $resultContainer) {
        var $activeRows = this.getActiveItineraryRows($itineraryGroups, $resultContainer);
        return $activeRows.length !== 0 && $activeRows.length === $itineraryGroups.length;
    },

    resetItineraryState($container) {
        this.$cachedSelectors.bookingError.addClass('hidden');

        $container.find('.itinerary_row').each(function(i, v) {
            $(v).removeClass('active-row hidden').find('input').prop('checked', false).removeClass('checked');
        });
    },

    disableResults() {
        this.$cachedSelectors.resultsContainer.animate({opacity: 0.7}, 400);
        this.$cachedSelectors.resultsDisabler.removeClass('hidden');
    },

    enableResults() {
        this.$cachedSelectors.resultsContainer.animate({opacity: 1}, 400);
        this.$cachedSelectors.resultsDisabler.addClass('hidden');
    },

    clearResults() {
        this.$cachedSelectors.resultsContainerScrollable.empty();
        this.$cachedSelectors.backToTopBtn.addClass('hidden');
        Odigeo.trigger(this.widget.id + ':clearResultsPagination');
        this.$cachedSelectors.resultsCreditCardContainer.addClass('hidden');
    },

    addResults(data, onComplete) {
        const widget = this.widget;
        let firstPage = widget.model.actualPage === 1;
        const docfrag = $('<div></div>');
        const container = this.$cachedSelectors.resultsContainerScrollable;
        const currentFareItineraries = widget.model.get('currentFareItineraries') || [];
        const items = [...currentFareItineraries];
        let moreResultsBottom;
        this._numAddedResults = 0;

        // Fill the "resultItemsStart" template and add it to the "docFrag"
        const itemsStartHtml = templatesUtils.template(this._templates.resultItemsStart)({searchType: data.searchType});
        docfrag.append(itemsStartHtml);

        // Among other things, add the "docFrag" to the DOM
        switch (this.widget.paginationType) {
            case 'loadMore':
                moreResultsBottom = (widget.pageBottomLoaded * widget.resultsByPage) < widget.model.numberOfFilteredResults;
                if (widget.pageBottomRequested === widget.pageBottomLoaded && widget.pageBottomLoaded === 1) {
                    this.clearResults();
                    firstPage = true;
                }
                if (firstPage && widget.pageBottomLoaded === 1) {
                    this.reloadCreditCardSelector(data.creditCardInfo);
                }
                if (widget.model.delta > 0) {
                    container.append(docfrag.data('page', widget.pageBottomRequested));
                } else if (widget.model.delta < 0) {
                    container.prepend(docfrag.data('page', widget.pageTopRequested));
                }
                Odigeo.trigger(this.widget.id + ':toggleNoMoreResults', moreResultsBottom);
                Odigeo.trigger(this.widget.id + ':togglePaginationContainer', !moreResultsBottom);
                break;
            case 'nPagesSet':
            case 'blockPagesSet':
                if (widget.model.actualPage === 1) {
                    this.reloadCreditCardSelector(data.creditCardInfo);
                }
                container.empty().append(docfrag);
                if (widget.model.totalPages !== 1) {
                    this.$cachedSelectors.paginationContainer.removeClass('hidden');
                }
                this.$cachedSelectors.resultsCreditCardContainer.removeClass('hidden');
                break;
        }

        // Process the result items in the JSON data, filling the HTML templates for each one and adding them
        // progressively to the DOM.
        items.forEach((item, i) => {
            // NOTE: This delay is just used to asynchronously insert the result elements into the DOM, preventing
            // the browser from blocking due to too many DOM elements being rendered at the same time.
            Odigeo._.delay(Odigeo._.bind(this._processAndRenderResult, this), i * 50, this._templates, data, item, i, docfrag, onComplete);
        });

        if (Odigeo.AB.isReturningVisitorsMobile && Odigeo.SessionScope.flow === 'mobile' && data.isMainBatch) {
            returningVisitTracking.trackReturningVisitor('results', items);
        }

        if (widget.options.showSingleDisclaimerItineraryResults && !Odigeo.Membership.isMembershipProductEnabledDesktop) {
            this._initDisclaimer(data);
        }
        if (!data.isDynPack) {
            Odigeo.trigger(this.widget.id + ':refreshCalendarGrid');
        }
        this.$cachedSelectors.appTouchpointBottom.toggleClass('odf-hidden', false);
        Odigeo.trigger(this.widget.id + ':resultsRefreshed', data.membershipSubscriptionPriceFmtd);
        this.$cachedSelectors.resultsLoader.addClass('hidden').removeClass('filter-single filter-multi');
        this.$cachedSelectors.resultsContainer.removeClass('invisible');
        this.widget.resultsTracking.trackAfterDrawResults();
    },

    scrollToSelectedItinerary() {
        const flightSelectionData = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData'));
        if (flightSelectionData) {
            const $selectedItinerary = this.widget.view.$el.find(`[data-fare-itinerary-id='${flightSelectionData.data.fareItineraryKey}']`);
            Odigeo.Utils.scrollToElement($selectedItinerary, {animation: false});
        }
    },

    _initDisclaimer(data) {
        var resultsDisclaimerTmpl = templatesUtils.template(this._templates.resultsDisclaimer)({
            fullPriceLegalDisplay: calculateFullPriceLegalDisplay(data.items[0], data),
            isBestPriceConfiguration: data.isBestPriceConfiguration,
            isMembershipFare: this.model.get('isMembershipFare'),
            isMembershipPriceOrDualPriceDisplay: data.isMembershipPriceDisplay || data.isMembershipDualPriceAbActive,
            legalTextBestPrice: data.legalTextBestPrice,
            legalTextBestPriceTip: data.legalTextBestPriceTip,
            legalTextFlexibilityDisruptionResultsC: data.legalTextFlexibilityDisruptionResultsC,
            legalTextFlexibilityDisruptionResultsD: data.legalTextFlexibilityDisruptionResultsD,
            isStickyPaymentDisclaimer: this.widget.options.isStickyPaymentDisclaimer,
        });

        this.$cachedSelectors.resultsDisclaimerDiv.html(resultsDisclaimerTmpl);
        $(window).on('scroll', Odigeo._.bind(this.allocateDisclaimer, this));
    },

    hideDisclaimer() {
        $('.disclaimer_wrapper').hide();
    },

    allocateDisclaimer() {
        var $disclaimer = $('.disclaimer_wrapper');
        var $window = $(window);
        var $resultsContainer = this.$cachedSelectors.resultsContainer;
        var stickermax = $resultsContainer.offset().top +
            $resultsContainer.outerHeight() + $disclaimer.outerHeight();
        var windowBottomPos = $window.scrollTop() + $window.height();

        $disclaimer.toggleClass('stick', windowBottomPos < stickermax);
    },

    onShowFaresDiscovery(e) {
        e.preventDefault();
        const $resultsContainer = $(e.target).parents('.result');
        const $discoveryExpanded = $resultsContainer.find('.membership_fares_discovery_expaned');
        $discoveryExpanded.slideDown(100, 'swing');
        $resultsContainer.find('.show_fares_discovery').addClass('odf-hidden');
        $resultsContainer.find('.fares_discovery_member_price').removeClass('odf-hidden');
        $discoveryExpanded.removeClass('odf-hidden');
        trackingUtils.trackEvent('results_list', 'show_more_fares');
        Odigeo.Session.set('userClickOnShowMoreFares', true);
    },

    onToggleFaresTooltip(e) {
        const $resultsContainer = $(e.target).parents('.result');
        $resultsContainer.find('.show_all_fares_tooltip').toggleClass('open');
        if (e.type === 'mouseover') {
            trackingUtils.trackEvent('results_list', 'show_more_fares_bubble');
        }
    },

    onClosePrimeFooterPopup(e) {
        const $primeFooterPopup = $(e.target).parents('.prime_footer_popup');
        $primeFooterPopup.removeClass('opened');
        trackingUtils.trackEvent('unlocked', 'explain_discount_bubble_close');
    },

    onClickPrimeLogoAtFooter() {
        trackingUtils.trackEvent('results_list', 'prime_logo_result_click');
    },

    templateSelectors: {
        resultFromMetaHighlighted: '.result-from-meta-highlighted',
        resultFromMetaTitle: '.result-from-meta-title',
        noResults: '.no_results_template',
        resultItemsStart: '.result-items-start',
        resultItemWrapper: '.result-item-wrapper',
        resultPriceBreakDown: '.result-price-breakdown',
        resultPriceBreakDownItem: '.price-breakdown-item',
        segmentStructure: '.segment-structure',
        segmentStructureRevamp: '.segment-structure-revamp',
        segmentCharterInfo: '.segment-charter-info',
        segmentHeader: '.segment-header',
        segmentHeaderMultipleLogos: '.segment_header_multiple_logos',
        singleLogo: '.single_logo',
        segmentSectionStop: '.segment-section-stop',
        segmentSectionStopCarrier: '.segment-section-stop-carrier',
        resultsDisclaimer: '.results_disclaimer',
        segmentItem: '.segment-item',
        appDownloadTouchPoint: '.app-download-touch-point',
        cancellationAndSeats: '.result-cancellation-seats',
        seatsLine: '.seats-resultcard',
        formattedPrice: '#formatted-price-template',
        emailCapture: '.email-capture-between-results',
        sortingTabsContainerTemplate: '.sorting_tabs_container_template',
        flexAlert: '.flex_alert_template',
        flightChangeFreeAlert: '.flight_change_free_alert_template',
        sortingTabTemplate: '.sorting_tab_template',
        sortingTabInfoTemplate: '.sorting_tab_data_template',
        odiRatingHeader: '.odirating_header_template',
        membershipBannerTop: '.membership-banner-results-top',
        membershipBannerBottom: '.membership-banner-results-bottom',
    },

    genericTemplatesSelectors: {},

    _extractTemplates() {
        var localTemplates = Odigeo._.reduce(this.templateSelectors, Odigeo._.bind(function(templates, selector, templateName) {
            templates[templateName] = this.$widget.find(selector).remove().html() || '';
            return templates;
        }, this), {});

        var genericTemplates = Odigeo._.reduce(this.genericTemplatesSelectors, function(templates, selector, templateName) {
            templates[templateName] = $(selector).html() || '';
            return templates;
        }, {});

        return Odigeo._.merge(localTemplates, genericTemplates);
    },

    _processAndRenderResult(templates, data, item, itemIndex, targetElem, onComplete) {
        let segItemsHtml;
        let segStructureHtml;
        let itemHtml;
        let itemPriceHtml = '';
        let itemResultPriceBreakDown = '';
        let itemItinerariesHtml = '';
        let isTrain = false;

        item.valueProposition = 0;
        const highlightedTag = this.calculateHighlightedTag(item);
        const isChangeFlightFreeChargeValid = this.isChangeFlightFreeChargeValid(item);
        const priceNextCtaEnabled = (!data.isDynPack && !data.isDualPriceDisplay && !item.isMembershipPriceOrDualPriceDisplay)
            || (!data.isDynPack && data.isTrainCard);

        const shallShowAppTouchpointBetweenResults = this.widget.options.isAppDownloadTouchPointBetweenResults
            && this.widget.pageBottomLoaded === 1 && itemIndex === 2;
        if (Odigeo.SessionScope.flow === 'mobile') {
            const initBanner = (template, id, options) => {
                targetElem.append(template);
                membershipBannerFactory().then(({default: factory}) => {
                    factory.create({
                        id,
                    }).execute('init', options);
                });
            };

            const isUserLogged = data.isUserLogged === 'true';
            if (parseInt(data.resultsMembershipBannerPosition, 10) === itemIndex) {
                initBanner(templates.membershipBannerTop, 'membership-banner-results-top', {isUserLogged});
            }
            if ((parseInt(data.resultsMembershipBannerPosition, 10) + parseInt(data.resultsMembershipBannerDistance, 10)) === itemIndex) {
                initBanner(templates.membershipBannerBottom, 'membership-banner-results-bottom', {straightStyle: true, isUserLogged});
            }
        }

        if (
            (Odigeo.AB.isEqualProminenceMeta || this.widget.options.isEqualProminenceMetaV2) &&
            Odigeo.SessionScope.isMeta
        ) {
            const numPassengers = item.numPassengers ? item.numPassengers : data.numPassengers;
            const priceWithDiscount = item.equalProminencePrimePrice / numPassengers;
            const priceWithoutDiscount = item.equalProminenceNonPrimePrice / numPassengers;
            trackingUtils.trackEventWithCategory(
                'flights_results',
                'prime_price_meta',
                `prime_price_meta-onload:from_${priceWithoutDiscount}_to_${priceWithDiscount}:choice_widget-pag:flights_results`
            );
        }

        item.itineraryGroupsList.forEach((itGroup, g) => {
            isTrain = isTrain || itGroup.transportType !== 'PLANE';
            segItemsHtml = '';
            const isOdirating = (highlightedTag === ODIRATING_TAG && g === 0)
                ? 'od-resultcard-segment-airline-name '
                : '';

            itGroup.segItems.forEach((segItem) => {
                itGroup.isSameIATAAirline = this.isSameIATAAirline(segItem);
                if (!segItem.carrierCode && itGroup.isSameIATAAirline) {
                    segItem = {
                        ...segItem,
                        carrierCode: itGroup.carrierCode,
                    };
                }
                const segmentItemView = new SegmentItemView({
                    sectionTemplates: {
                        segmentSectionStop: templates.segmentSectionStop,
                        segmentSectionStopCarrier: templates.segmentSectionStopCarrier,
                        singleLogo: this._templates.singleLogo,
                        multipleLogos: this._templates.multipleLogos,
                    },
                    segmentItemTemplate: templatesUtils.template(templates.segmentItem),
                    isNativeInput: this.widget.isNativeInput,
                    widgetOptions: this.widget.options,
                    lastItineraryGroup: g === item.itineraryGroupsList.length - 1,
                    isChangeFlightFreeChargeValid,
                    flightChangeFreeClass: this.getChangeFlightMessageClass(isChangeFlightFreeChargeValid),
                    flightChangeEligibleClass: this.getChangeFlightMessageClass(isChangeFlightFreeChargeValid, true),
                    priceNextCtaEnabled,
                    isLoggedInPrimeMember: data.isMembershipPriceDisplay,
                    segItem,
                    itGroup,
                    item,
                    data,
                    isTrain,
                });
                segItemsHtml += segmentItemView.render().$el.html();
            });

            segStructureHtml = templatesUtils.template(
                Odigeo.AB.isResultsBoxRevampDesktop ? templates.segmentStructureRevamp : templates.segmentStructure)({
                count: itGroup.count,
                isHubItinerary: itGroup.isHubItinerary,
                isSmartHubItinerary: itGroup.isSmartHubItinerary,
                isSameIATAAirline: itGroup.isSameIATAAirline,
                destinationsText: (data.searchType === 'MULTIPLE_DESTINATIONS' ? itGroup.resultOtherNumbText : itGroup.resultOtherText),
                segmentCharterInfo: this._fillSegmentCharterInfo(templates.segmentCharterInfo, itGroup, data),
                segmentHeader: this._fillSegmentHeaderTemplate(templates, itGroup, data, isOdirating),
                segmentItems: segItemsHtml,
                isResultsBoxRevampDesktop: Odigeo.AB.isResultsBoxRevampDesktop,
                isLastItineraryGroup: g === item.itineraryGroupsList.length - 1,
                isTrainCard: data.isTrainCard,
            });

            itemItinerariesHtml += segStructureHtml;
        });

        Odigeo.trigger(this.widget.id + ':addSharedLegalDisclaimer', item, data);

        if (!data.isDynPack && templates.resultPriceBreakDown && templates.resultPriceBreakDownItem) {
            itemResultPriceBreakDown = this._fillPriceBreakDownTemplate(templates.resultPriceBreakDown,
                templates.resultPriceBreakDownItem, item, data);
        }

        itemHtml = this._fillSegItemWrapperTemplate(templates.resultItemWrapper, itemIndex, item, data,
            itemPriceHtml, itemItinerariesHtml, itemResultPriceBreakDown, highlightedTag);

        let $itemHtml = $(itemHtml);
        const $freeCancellation = $itemHtml.find('.free_cancellation_hours');

        if ($freeCancellation.length > 0) {
            $freeCancellation.html(Odigeo.Utils.pluralizeAll($freeCancellation.data('pluralforms'),
                $freeCancellation.data('freecancellation')));
        }

        const fareItineraryIdFromMetaSearch = data.fareItineraryFromMetaSearch ? data.fareItineraryFromMetaSearch.mainItineraryId : null;
        if (this.model.landingToResultsFromMeta(data) && item.mainItineraryId === fareItineraryIdFromMetaSearch) {
            const infoOtherOffers = this._fillMetaResultHighlightedTemplate(
                templates.resultFromMetaHighlighted,
                templates.resultFromMetaTitle, $(itemHtml),
            );
            $itemHtml = $(infoOtherOffers);

            setTimeout(() => {
                tagManagement.fireEvent('price_available', 'product_total_price_dom', item.equalProminenceNonPrimePrice);
            }, 2500);
        }

        if (shallShowAppTouchpointBetweenResults) {
            targetElem.append(templates.appDownloadTouchPoint);
            this.createAppTouchpoint('betweenresults', 'app_download_middle');
        }

        $itemHtml.appendTo(targetElem);

        const hasMetaBox = Odigeo.SessionScope.isMetaFlights && this.model.landingToResultsFromMeta(data);
        if (!hasMetaBox && highlightedTag === ODIRATING_TAG) {
            new OdiRatingHeaderView({
                el: '.odirating_header_container',
                item: item,
                template: Odigeo._.template(this._templates.odiRatingHeader, Odigeo.Utils.getTmplSettings()),
                tests: this.widget.options.tests,
                translations: this.widget.options.translations,
                numAdvantagesShown: this.widget.options.numAdvantagesShown,
            }).render();
        }
        if (this.priceAlertBannerHasToBeShown(itemIndex) && !isDynpack) {
            this.showPriceAlertBanner(targetElem);
        }

        this._numAddedResults++;
        const itemLength = data.items.length - 1;
        if (this._numAddedResults >= itemLength) {
            const isFirstBatch = false;
            const eventToTrigger = isFirstBatch ? ':renderResultsProcess' : ':resultsAdded';
            Odigeo.trigger(this.widget.id + eventToTrigger);
            onComplete(targetElem);
        }

        loadAtolWidgets([`atol-protected-flight-card-${itemIndex}`], {hasTooltip: true});
    },

    isFreeCancellation(item) {
        return item.freeCancellationHoursApart > 0
            && Odigeo._.get(this, 'widget.options.isFreeCancellation', false)
            && !item.isNegoFare;
    },

    isSameIATAAirline(segItem) {
        const getIATACodesFromSegment = segItem.flightNumbers.match(/\D/g).join('').split(',');
        const getUniqueIATACode = new Set(getIATACodesFromSegment);
        getUniqueIATACode.delete('');
        return getUniqueIATACode.size <= 1;
    },

    _fillSegmentHeaderTemplate(templates, itineraryGroup, data, isOdirating) {
        const segmentHeaderTemplate = this.widget.options.tests.newResultCardEnabled ?
            templates.segmentHeaderMultipleLogos : templates.segmentHeader;

        let segHeaderHtml;
        let resultTitleTextValue;
        let hasSegments;
        let firstSegment;
        const emptySegment = function() {
            return {
                isCharter: false,
                charterWarningDates: '',
                charterWarningHours: '',
                charterNewDeparture: '',
                departureDate: '',
                departureInfo: {
                    date: '',
                },
            };
        };
        const transportTypeIconMap = {
            OUTBOUND: {
                PLANE: 'odf-icon-plane-going',
                TRAIN: 'odf-icon-train-right',
                MIX_PLANE_TRAIN: 'odf-icon-combination-fl-train-a',
            },
            INBOUND: {
                PLANE: 'odf-icon-plane-returning',
                TRAIN: 'odf-icon-train-right',
                MIX_PLANE_TRAIN: 'odf-icon-combination-fl-train-b',
            },
        };
        const createIconClass = function(model, searchType) {
            var segmentDirection = (searchType === 'MULTIPLE_DESTINATIONS' || model.count === 1) ? 'OUTBOUND' : 'INBOUND';
            return transportTypeIconMap[segmentDirection][model.transportType];
        };

        const resultTitleTextValues = {
            'ONE_WAY': Odigeo.SessionScope.flow === 'mobile' ? '' : itineraryGroup.resultSegmentName,
            'ROUND_TRIP': itineraryGroup.resultSegmentName,
            'MULTIPLE_DESTINATIONS': itineraryGroup.resultFlightText,
        };

        resultTitleTextValue = resultTitleTextValues[data.searchType];
        hasSegments = itineraryGroup.segItems.length > 0;
        firstSegment = hasSegments ? itineraryGroup.segItems[0] : emptySegment();
        segHeaderHtml = templatesUtils.template(segmentHeaderTemplate)({
            transportType: itineraryGroup.transportType,
            trainIcon: itineraryGroup.trainIcon,
            flightIcon: itineraryGroup.flightIcon,
            iconClass: createIconClass(itineraryGroup, data.searchType),
            resultTitleText: resultTitleTextValue,
            headerFormatedDate: itineraryGroup.headerFormatedDate,
            carrierName: itineraryGroup.carrierName,
            isHubItinerary: itineraryGroup.isHubItinerary,
            isSmartHubItinerary: itineraryGroup.isSmartHubItinerary,
            isSameIATAAirline: itineraryGroup.isSameIATAAirline,
            airlineImageIcon: itineraryGroup.airlineImageIcon,
            allAirlineImageIcons: itineraryGroup.allAirlineImageIcons,
            multipleLogos: buildMultipleLogos(itineraryGroup.allAirlineImageIcons, templates, itineraryGroup.carrierName, data.multipleCarriersText),
            count: itineraryGroup.count,
            multipleAirlinesText: data.multipleAirlinesText,
            isCharter: firstSegment.isCharter,
            charterWarningDates: firstSegment.charterWarningDates,
            charterWarningHours: firstSegment.charterWarningHours,
            charterNewDeparture: firstSegment.charterNewDeparture,
            departureDate: firstSegment.departureInfo.date,
            isOdirating,
            multipleCarriersText: data.multipleCarriersText,
        });
        return segHeaderHtml;
    },

    buildMultipleLogos,

    _fillSegmentCharterInfo(segmentCharterTemplate, itineraryGroup, data) {
        var segCharterHtml;
        var resultTitleTextValue;
        var hasSegments;
        var firstSegment;
        var emptySegment = function() {
            return {
                isCharter: false,
                charterWarningDates: '',
                charterWarningHours: '',
                charterNewDeparture: '',
                departureDate: '',
            };
        };

        resultTitleTextValue = itineraryGroup.resultSegmentName;
        if (data.searchType === 'MULTIPLE_DESTINATIONS') {
            resultTitleTextValue = itineraryGroup.resultFlightText;
        }
        hasSegments = itineraryGroup.segItems.length > 0;
        firstSegment = hasSegments ? itineraryGroup.segItems[0] : emptySegment();
        segCharterHtml = templatesUtils.template(segmentCharterTemplate)({
            resultTitleText: resultTitleTextValue,
            isCharter: firstSegment.isCharter,
            charterWarningDates: firstSegment.charterWarningDates,
            charterWarningHours: firstSegment.charterWarningHours,
            charterNewDeparture: firstSegment.charterNewDeparture,
        });
        return segCharterHtml;
    },

    fillSegCancellationSeatsTemplate(item, data, numSeats) {
        return this.widget.options.tests.newResultCardEnabled ?
            templatesUtils.template(this._templates.seatsLine)(this.getSeatsLeftData(data, numSeats)) :
            templatesUtils.template(this._templates.cancellationAndSeats)(this.getSegCancellationSeatsData(item, data, numSeats));
    },

    getSeatsLeftData(data, numSeats) {
        return {
            isShown: numSeats > 0 && numSeats < 10,
            message: this.getSeatsLeftCopy(numSeats, data),
            secondaryMessage: this.getSecondaryMessage(numSeats, data),
            additionalStyle: Odigeo.AB.isCssVariationMobile ? 'odf-text-md odf-strong'
                : (Odigeo.Membership.isPrimeUkResultsBoxMobile && !isDynpack) ? 'odf-text-md' : 'odf-text-sm odf-strong',
        };
    },

    getSegCancellationSeatsData(item, data, numSeats) {
        return {
            seatsLeft: this.getSeatsLeftData(data, numSeats),
            freeCancellationHoursApart: item.freeCancellationHoursApart,
            isFreeCancellationEnabled: this.widget.options.isFreeCancellation,
            newResultsHeaderColourClass: numSeats > 0 && numSeats < 6 ? 'odf-text-negative' : 'od-normal-colour',
        };
    },

    getSeatsLeftCopy(numSeats, data) {
        var options = this.widget.options;
        var copy = options.translations.seatsLeft;

        numSeats = numSeats || 0;

        if (numSeats === data.numPassengers) {
            copy = data.translations.seatsLeft.lastSeatLeft;
        }

        return Odigeo.Utils.pluralizeAll(copy, numSeats);
    },

    _fillPriceBreakDownTemplate(resultPriceBreakDownTemplate, resultPriceBreakDownItemTemplate, item, data) {
        var priceBreakDownHtml;
        var priceBreakDownItemsHtml = '';
        var pbdTotalOrSubTotalTextValue = '';
        var hasTax = true;
        var getPaymentFeeDescription = function() {
            var ccFeeText = item.ccFee > 0 ? data.paymentFeePositiveText : data.paymentFeeNegativeText;
            return item.isMembershipPriceOrDualPriceDisplay ? data.membershipPricePaymentFeeText : ccFeeText;
        };

        // Process the templates for each of the price break down entries
        Odigeo._.each(item.priceBreakDownItems, function(item) {
            // check hasTax prop for priceBreakDownHtml itinerary template
            // in order to show disclaimer in priceBreakdown when is false
            // Test AB OFIS-79
            if (data.pricebreakdownShowingTaxAndFeeDesktop) {
                hasTax = hasTax ? (item && item.hasTax) : hasTax;
            }

            priceBreakDownItemsHtml += templatesUtils.template(resultPriceBreakDownItemTemplate)(item);
        });

        if (data.isFullPriceConfigurationEnabled) {
            pbdTotalOrSubTotalTextValue = data.priceTotalText;
        } else if (data.isBestPriceConfiguration) {
            pbdTotalOrSubTotalTextValue = data.priceSubTotalText;
        }
        const numPassengers = item.numPassengers ? item.numPassengers : data.numPassengers;
        // Processes the main price break down template
        priceBreakDownHtml = templatesUtils.template(resultPriceBreakDownTemplate)({
            priceBreakDownSubTitle: data.priceBreakDownSubTitle,
            pbdPassengerText: data.pbdPassengerText,
            pbdAllPassengersText: data.pbdAllPassengersText,
            pbdPriceText: data.pbdPriceText,
            pbdPriceFareText: data.pbdPriceFareText,
            pbdPriceTaxText: data.pbdPriceTaxText,
            pbdQuantityText: data.pbdQuantityText,
            pbdTotalPriceText: data.pbdTotalPriceText,
            totalPricePassengersSum: item.totalPricePassengersSum,
            totalPricePassengersSumFormatted: item.totalPricePassengersSumFormatted,
            totalProviderPricePassengersSumFormatted: item.totalProviderPricePassengersSumFormatted,
            isFullPriceConfigurationEnabled: data.isFullPriceConfigurationEnabled,
            isFullTablePriceBreakDownOnFullPrice: data.isFullTablePriceBreakDownOnFullPrice,
            isMembershipPriceDisplay: data.isMembershipPriceDisplay,
            isMembershipDualPriceDisplay: item.isMembershipDualPriceDisplay,
            isMembershipPriceOrDualPriceDisplay: item.isMembershipPriceOrDualPriceDisplay,
            isMembershipShowPriceDisclaimer: item.isMembershipShowPriceDisclaimer,
            pbdServicesFeeText: data.pbdServicesFeeText,
            serviceFee: item.serviceFee,
            serviceFeeFormatted: item.serviceFeeFormatted,
            markupFormatted: item.markupFormatted,
            serviceFeeQuantity: item.serviceFeeQuantity,
            serviceFeePerQuantityFormatted: item.serviceFeePerQuantityFormatted,
            showPaymentFeeWhenZero: data.showPaymentFeeWhenZero,
            showFeesQuantityAlwaysOne: data.showFeesQuantityAlwaysOne,
            showNetTaxSeparately: data.showNetTaxSeparately,
            ccFee: item.ccFee,
            ccFeeFormatted: item.ccFeeFormatted,
            paymentFeeDescription: getPaymentFeeDescription(),
            isBestPriceConfiguration: data.isBestPriceConfiguration,
            discountFeeAllPrice: item.discountFeeAllPrice,
            discountFeeAllPriceFormatted: item.discountFeeAllPriceFormatted,
            priceDiscountTitleText: data.priceDiscountTitleText,
            priceDiscountSubTitleText: data.priceDiscountSubTitleText,
            totalFee: item.totalFee,
            totalFeeFormatted: item.totalFeeFormatted,
            baggageQuantity: item.baggageQuantity,
            baggageOnePrice: item.baggageOnePrice,
            baggageOnePriceFormatted: item.baggageOnePriceFormatted,
            pcbFareTotalPrice: item.pcbFareTotalPrice,
            pcbFareTotalPriceFormatted: item.pcbFareTotalPriceFormatted,
            priceBaggagesText: data.priceBaggagesText,
            pbdTotalOrSubTotalText: pbdTotalOrSubTotalTextValue,
            pricePerPassengerText: data.pricePerPassengerText,
            showPricePerPassenger: data.showPricePerPassenger,
            pricePerPassenger: item.pricePerPassenger,
            pricePerPassengerFormatted: item.pricePerPassengerFormatted,
            numPassengers: numPassengers,
            isBestPriceDiscountMinusTaxes: data.isBestPriceDiscountMinusTaxes,
            pcbBestPriceDisclaimerText: data.pcbBestPriceDisclaimerText,
            pcbBestPriceLatamDisclaimerText: data.pcbBestPriceLatamDisclaimerText,
            pcbBaggageDisclaimerText: data.pcbBaggageDisclaimerText,
            isDefaultPdbLegalText: item.isDefaultPdbLegalText,
            legalTextPbdPayment: item.legalTextPbdPayment,
            priceBreakDownItems: priceBreakDownItemsHtml,
            pricebreakdownShowingTaxAndFee: data.pricebreakdownShowingTaxAndFeeDesktop,
            pricebreakdownShowingRealProviderFare: data.pricebreakdownShowingRealProviderFareDesktop,
            hasTax: hasTax,
            taxDisclaimer: data.taxDisclaimer,
            shouldShowSlashedPrice: shouldShowSlashedPrice(
                this.widget.options.isSlashedPricePartition, item.diffBetweenSlashedAndNormalPrice),
            diffBetweenSlashedAndNormalPriceFormatted: item.diffBetweenSlashedAndNormalPriceFormatted,
        });

        return priceBreakDownHtml;
    },

    getItineraryCarriers(itineraryData = []) {
        return Odigeo._.uniq(Odigeo._.flatten(itineraryData.reduce((acc, segment) => {
            const segItems = Odigeo._.get(segment, 'segItems', []);
            const segmentCarriers = segItems.map((segmentItem) => {
                const flightNumbers = Odigeo._.get(segmentItem, 'flightNumbers', '');
                return changeFlightFreeChargeUtils.getCarriersFromFlightNumbers(flightNumbers);
            });
            return acc.concat(segmentCarriers);
        }, [])));
    },

    isChangeFlightFreeChargeValid(item) {
        const itineraryData = Odigeo._.get(item, 'itineraryGroupsList', []);
        const itineraryCarriers = this.getItineraryCarriers(itineraryData);
        return changeFlightFreeChargeUtils.isChangeFlightFreeChargeValid(itineraryCarriers);
    },

    calculateHighlightedTag(item) {
        return item.odiRating.highlightedTag;
    },

    getChangeFlightMessageClass(isValid, returnEligibleClass) {
        let flightChangeFreeClass = '';
        let flightChangeEligibleClass = '';
        if (Odigeo.AB.isChangeFlightFreeChargeDesktop || Odigeo.AB.isChangeFlightFreeChargeMobile || Odigeo.AB.isPrimeDays) {
            if (isValid) {
                flightChangeFreeClass = 'change_flight_free_available';
            } else {
                flightChangeEligibleClass = 'date_change_option_eligible';
            }
        }
        return returnEligibleClass ? flightChangeEligibleClass : flightChangeFreeClass;
    },

    getPriceDiscountDynpack(item) {
        const dpDiscountPercentage = Odigeo._.get(item, 'dynpackPriceDiscount.discountPercentage', 0);
        const dynpackFare = (dpDiscountPercentage > 0);
        return getPriceDiscountDataDPCommon({
            pricePerPassengerWithoutDiscount: Odigeo._.get(item, 'dynpackPriceDiscount.pricePerPassengerWithoutDiscount'),
            discountPercentage: dpDiscountPercentage,
            price: Odigeo._.get(item, 'dynpackPriceDiscount.priceByProduct'),
            dynpackFare,
            hasInfoDiscount: dynpackFare,
        });
    },

    getDynpackPrices(item, isFullPriceSelected) {
        const isPrimePricing = Odigeo.AB.isDynpackPrimeEnable && !isFullPriceSelected;
        const priceDiscountDynpack = this.getPriceDiscountDynpack(item);
        const priceBreakdownDynpack = Odigeo._.get(item, 'priceBreakdownDynpack', {});
        const primePriceData = Odigeo.AB.isDynpackPrimeEnable ? getPrimePriceDataDPCommon(priceBreakdownDynpack) : null;
        let pricePerPassengerWithoutDiscount = priceDiscountDynpack.hasMinimumDiscount ? priceDiscountDynpack.formatFareDiscountPrice : null;
        let pricePerPassenger = item.price;
        let discountPercentage = priceDiscountDynpack.fareDiscountPercentage;

        if (isPrimePricing) {
            // Prime Pricing
            pricePerPassengerWithoutDiscount = primePriceData.pricePrimeSlashedDataBreakDown;
            pricePerPassenger = primePriceData.primePriceBreakdown.quantity;
            discountPercentage = (1 - pricePerPassenger / pricePerPassengerWithoutDiscount.quantity) * 100;
        } else if (Odigeo.AB.isDynpackPrimeEnable) {
            // Full Price selected in Prime
            pricePerPassengerWithoutDiscount = priceDiscountDynpack.hasMinimumDiscount ? primePriceData.pricePrimeSlashedDataBreakDown : 0;
            pricePerPassenger = primePriceData.slashedPrimePriceDataBreakDown.quantity;
            discountPercentage = (1 - pricePerPassenger / pricePerPassengerWithoutDiscount.quantity) * 100;
        }

        return {
            pricePerPassenger,
            pricePerPassengerWithoutDiscount,
            discountPercentage: Math.floor(discountPercentage),
        };
    },

    createTemplateDataFromItinerary(resultItemWrapperTemplate, itemIndex, item, data,
        itemPriceHtml, itemItinerariesHtml, itemResultPriceBreakDown, info, highlightedTag) {
        const options = this.widget.options;
        const config = options.config;
        const tests = options.tests;
        let slashedPrice = '';
        const formattedPriceTemplate = templatesUtils.template(this._templates.formattedPrice);
        const isChangeFlightFreeChargeValid = this.isChangeFlightFreeChargeValid(item);
        const numPassengers = item.numPassengers ? item.numPassengers : data.numPassengers;
        const isRecommended = function(highlightedTag, isMetaBox) {
            return highlightedTag !== ODIRATING_TAG && highlightedTag !== NONE_TAG && !isMetaBox;
        };
        const getHighlightedObject = function(highlightedTag, isMetaBox) {
            return (isRecommended(highlightedTag, isMetaBox) || highlightedTag === ODIRATING_TAG) && !isMetaBox
                ? highlightedLayoutMap[highlightedTag] : highlightedLayoutMap.NONE;
        };
        const {
            membershipPriceDisplayDesktop,
            membershipPriceDisplayMobile,
        } = Odigeo.Membership;
        const isDualPrice = options.isDualPrice;
        const showAsteriskDesktop = !data.isMembershipPriceDisplay && !data.isMembershipDualPriceDisplay &&
            !(data.showResultsPriceBreakDown && !data.isDynPack && data.isDualPriceDisplay);
        const showAsteriskMobile = !(data.isMembershipPriceDisplay || data.isMembershipDualPriceAbActive) && !data.isDynPack;
        const showAsterisk = config.device === 'desktop' ? showAsteriskDesktop : showAsteriskMobile;
        const mainPriceClasses = priceUtils.buildMainPriceClasses({
            device: config.device,
            isMembershipPriceDisplay: data.isMembershipPriceDisplay,
            isFullPriceConfigurationEnabled: data.isFullPriceConfigurationEnabled,
            isDualPriceSelectable: data.isDualPriceSelectable,
            isDualPriceDisplay: data.isDualPriceDisplay,
            membershipPriceDisplayDesktop,
            membershipPriceDisplayMobile,
            numSeatsLeft: info.seatsLeft.num,
            tests: tests,
            ctaPriceEnabled: options.ctaPriceEnabled,
            isDynPack: data.isDynPack,
            isTrainCard: data.isTrainCard,
        });
        const redSlashedClass = Odigeo._.inRange(info.seatsLeft.num, 1, 6) ? ' od-red-slashed' : '';
        const membershipSlashedPriceObj = buildPriceObj({
            price: item.membershipSlashedPrice,
            showPriceDecimals: data.showPriceDecimals,
        }, {
            container: 'od-resultpage-slash-container membership_slashed_price_container' + redSlashedClass,
            generic: 'odf-text-md',
            integer: 'od-resultpage-slashed-price-int',
        }, data.currency);

        const membershipSlashedPriceBottomObj = buildPriceObj({
            price: item.membershipSlashedPrice,
            showPriceDecimals: data.showPriceDecimals,
        }, {
            container: 'odf-text-negative',
            generic: `odf-text-lg odf-text-mono-color-04`,
        }, data.currency);

        const priceWithoutDiscountObj = buildPriceObj({
            price: item.equalProminenceNonPrimePrice / numPassengers,
            showPriceDecimals: data.showPriceDecimals,
        }, {
            generic: 'odf-text-2lg odf-strong price_label',
        }, data.currency);

        const expandableSlashedPriceObj = buildPriceObj({
            price: item.membershipSlashedPrice,
            showPriceDecimals: data.showPriceDecimals,
        }, {
            container: 'odf-text-mono-color-05' + (Odigeo.SessionScope.isMetaFlights ? '' : ' odf-text-line-through'),
            generic: 'odf-text-lg odf-text-mono-color-05',
        }, data.currency);

        const membershipSubscriptionPriceTxt = Odigeo.Utils.replaceCmsKeyArgs(data.membershipSubscriptionPriceTxt,
            data.membershipSubscriptionPriceFmtd);
        const membershipEmptyButtonSubscriptionPriceTxt = Odigeo.Utils.replaceCmsKeyArgs(data.membershipEmptyButtonSubscriptionPriceTxt,
            data.membershipSubscriptionPriceFmtd);
        const membershipExpandedButtonsSubscriptionPriceTxt = Odigeo.Utils.replaceCmsKeyArgs(data.membershipExpandedButtonsSubscriptionPriceTxt,
            data.membershipSubscriptionPriceFmtd);
        const membershipFaresDiscoverySubscriptionPriceTxt = Odigeo.Utils.replaceCmsKeyArgs(data.membershipFaresDiscoverySubscriptionPriceTxt,
            data.membershipSubscriptionPriceFmtd);
        const primeMembershipShowAllFaresDescription = Odigeo.Utils.replaceCmsKeyArgs(data.primeMembershipShowAllFaresDescription,
            membershipFaresDiscoverySubscriptionPriceTxt);
        const primeMembershipShowAllFaresSubtitle = (data.primeMembershipShowAllFaresSubtitle) ?
            data.primeMembershipShowAllFaresSubtitle + data.membershipSubscriptionPriceFmtd : '';
        const ctaPriceEnabled = options.ctaPriceEnabled && !data.isDynPack && !data.isDualPriceDisplay
            && !item.isMembershipPriceOrDualPriceDisplay;
        const priceNextCtaEnabled = (!data.isDynPack && !data.isDualPriceDisplay && !item.isMembershipPriceOrDualPriceDisplay)
            || (!data.isDynPack && data.isTrainCard);
        const membershipFaresDiscoveryPrimePriceDiscountTxt = Odigeo.Utils.replaceCmsKeyArgs(data.membershipFaresDiscoveryPrimePriceDiscountTxt,
            item.ccFeeFormatted);
        const membershipPriceAtFooterSavingMessageTitle = Odigeo.Utils.replaceCmsKeyArgs(data.membershipPriceAtFooterSavingMessageTitle,
            item.ccFeeFormatted);
        const membershipPriceAtFooterPopupText = Odigeo.Utils.replaceCmsKeyArgs(data.membershipPriceAtFooterPopupText,
            data.membershipUserName);
        const equalProminenceLabelMetaText = $('#equal_prominence_label_meta_container').html();

        let dpPricePerPassenger = null;
        let dpPricePerPassengerWithoutDiscount = null;
        let dpDiscountPercentage = null;
        let differentialPricePerPax = null;
        let tripTotalPrice = null;

        if (data.isDynPack) {
            const dpPrice = this.getDynpackPrices(item, data.isDynpackPriceWithoutDiscountSelected);
            const {differentialPricePerPassenger, totalPrice} = item.priceBreakdownDynpack;
            const differentialPricePrefix = differentialPricePerPassenger < 0 ? '-' : '+';
            dpPricePerPassenger = dpPrice.pricePerPassenger;
            dpPricePerPassengerWithoutDiscount = dpPrice.pricePerPassengerWithoutDiscount;
            dpDiscountPercentage = dpPrice.discountPercentage;
            differentialPricePerPax = Odigeo._.extend(getPriceFormat(differentialPricePerPassenger), {differentialPricePrefix});
            const total = Odigeo.AB.isDynpackMobilePrime ? dpPricePerPassenger * numPassengers : totalPrice;
            tripTotalPrice = getPriceFormat(total);
        }

        const mainPrice = formattedPriceTemplate(buildPriceObj({
            price: data.isDynPack ? dpPricePerPassenger : (item.equalProminencePrimePrice / numPassengers),
            showPriceDecimals: data.showPriceDecimals,
            showAsterisk: showAsterisk,
        }, mainPriceClasses, data.currency));

        const mainDynpackPrimePrice = formattedPriceTemplate(buildPriceObj({
            price: dpPricePerPassenger,
            showPriceDecimals: data.showPriceDecimals,
            showAsterisk: showAsterisk,
        }, mainPriceClasses, data.currency));

        const nonPrimePrice = formattedPriceTemplate(buildPriceObj({
            price: item.membershipSlashedPrice,
            showPriceDecimals: data.showPriceDecimals,
            showAsterisk: showAsterisk,
        }, mainPriceClasses, data.currency));

        const membershipDisclaimer = Odigeo.Utils.replaceCmsKeyArgs(
            data.membershipFareFilterPriceDisclaimer,
            data.membershipSubscriptionPriceFmtd,
            item.ccFeeFormatted,
        );

        if (options.isSlashedPricePartition) {
            slashedPrice = formattedPriceTemplate(buildPriceObj({
                price: item.slashedPrice,
                showPriceDecimals: data.showPriceDecimals,
            }, {
                container: 'od-resultpage-slash-container slashed_price' + redSlashedClass,
                generic: 'odf-text-md',
                integer: 'od-resultpage-slashed-price-int',
            }, data.currency));
        }

        const firstItem = data.items && data.items[0];
        const showOnFirstItem = itemIndex === 0 && highlightedTag !== ODIRATING_TAG;
        const showOnSecondItem = itemIndex === 1 && this.calculateHighlightedTag(firstItem) === ODIRATING_TAG;
        const isMembershipDualPriceAbActive = data.isMembershipDualPriceAbActive && Odigeo.SessionScope.flowProduct !== 'dp';
        const hasMetaBox = Odigeo.SessionScope.isMetaFlights && this.model.landingToResultsFromMeta(data);
        return {
            bookingRating: item.odiRating.bookingRating,
            charterWarningDates: item.isDistinctDates,
            charterWarningHours: item.isDistinctTimes,
            ctaButton: createCTATexts.call(this, data, item, mainPrice, ctaPriceEnabled, options.ctaTextEnabled),
            ctaPriceEnabled,
            debugInfo: item.debugInfo,
            disclaimerCurrency: item.disclaimerCurrency,
            fareItinerarySearchId: item.fareItinerarySearchId,
            fareItineraryType: item.fareItineraryType,
            fareUpgradeSelectorInstance: this.fareUpgradeSelectorInstance,
            freeCancellationHoursApart: item.freeCancellationHoursApart,
            fullPriceLegalDisplay: calculateFullPriceLegalDisplay(item, data),
            hasMktPortals: data.hasMktPortals,
            hidePrimeBannerResults: data.hidePrimeBannerResults,
            isFrontendShellEnabled: Odigeo.AB.isFrontendShellEnabled,
            resultsMembershipBannerPosition: data.resultsMembershipBannerPosition,
            resultsMembershipBannerDistance: data.resultsMembershipBannerDistance,
            highlightedObject: getHighlightedObject(highlightedTag, item.isFromMetaSearch),
            highlightedTag: highlightedTag,
            isBestPriceConfiguration: data.isBestPriceConfiguration,
            isCharter: item.isFlightCharter,
            isCommunicationFullTransparency: data.isCommunicationFullTransparency,
            isDualPrice,
            isDualPriceDisplay: data.isDualPriceDisplay,
            isDynPack: data.isDynPack,
            isAtolProtected: item.isAtolProtected,
            isFontSizeInPriceNextToCta: tests.isFontSizeInPriceNextToCta,
            isFreeCancellationEnabled: options.isFreeCancellation,
            isFromMeta: item.isFromMetaSearch,
            isMembershipDualPriceDisplay: item.isMembershipDualPriceDisplay,
            isMembershipFare: this.model.get('isMembershipFare'),
            isMembershipPriceDisplay: data.isMembershipPriceDisplay,
            isMembershipPriceOrDualPriceDisplay: item.isMembershipPriceOrDualPriceDisplay,
            isMembershipProductEnabled: Odigeo.Membership.isMembershipProductEnabled,
            isPrimePrice: Odigeo.SessionScope.isPrimePrice,
            isRecommended: isRecommended(highlightedTag, item.isFromMetaSearch),
            itemContent: itemItinerariesHtml,
            itemIndex: this.getItemIndex(itemIndex),
            itemPriceContent: itemPriceHtml,
            legalTextBestPrice: data.legalTextBestPrice,
            legalTextPriceBreakDownDefaultCC: item.legalTextPriceBreakDownDefaultCC,
            mainItineraryId: item.mainItineraryId,
            mainPrice,
            cardPrice: this.model.get('isMembershipFare') ? mainPrice : nonPrimePrice,
            isPrimeToggleEnabled: Odigeo.Membership.membershipPriceDisplayMobile == 'TOGGLE_BUTTON' && !Odigeo.Membership.isPrimeUkResultsBoxMobile,
            membershipDisclaimer,
            membershipEmptyButtonSubscriptionPriceTxt,
            membershipExpandableHeaderDisclaimer: data.membershipExpandableHeaderDisclaimer,
            membershipExpandablePrimeSectionDisclaimer: data.membershipExpandablePrimeSectionDisclaimer,
            membershipExpandableStandardSectionDisclaimer: data.membershipExpandableStandardSectionDisclaimer,
            membershipExpandedButtonsSubscriptionPriceTxt,
            membershipFareFilterPriceDescription: data.membershipFareFilterPriceDescription,
            membershipFaresDiscoveryPriceDescription: data.membershipFaresDiscoveryPriceDescription,
            membershipFaresDiscoveryPrimePriceDiscountTxt,
            membershipFaresDiscoverySubscriptionPriceTxt,
            primeMembershipShowAllFaresDescription,
            primeMembershipShowAllFaresSubtitle,
            fareDiscoveryPrimeDescription: options.translations.fareDiscoveryPrimeDescription,
            membershipPriceAtFooterSavingMessageTitle,
            membershipPriceAtFooterSavingMessageText: data.membershipPriceAtFooterSavingMessageText,
            membershipPriceAtFooterPopupText,
            showPrimeFooterPopup: showOnFirstItem || showOnSecondItem,
            isMembershipFlexibilityD: Odigeo.Membership.isMembershipFlexibilityD && !isDynpack,
            membershipSlashedPrice: formattedPriceTemplate(membershipSlashedPriceObj),
            membershipSlashedPriceBottom: formattedPriceTemplate(membershipSlashedPriceBottomObj),
            membershipSlashedPriceInt: item.membershipSlashedPrice,
            membershipSlashedPriceObj: membershipSlashedPriceObj.price,
            membershipSubscriptionBubbleDescTxt: info.membershipSubscriptionBubbleDescTxt,
            membershipSubscriptionPriceFmtd: data.membershipSubscriptionPriceFmtd,
            membershipSubscriptionPriceTxt: membershipSubscriptionPriceTxt,
            isMembershipFreeTrial: Odigeo.Membership.isMembershipFreeTrial,
            membershipTotalDiscount: item.serviceFeeFormatted,
            isPrimeUkResultsBoxMobile: Odigeo.Membership.isPrimeUkResultsBoxMobile,
            nonPrimePrice,
            numberOfSegments: item.numberOfSegments,
            passengerDetails: data.passengerDetails,
            pluralizeAll: Odigeo.Utils.pluralizeAll,
            precalculatedRefundableFareUpgradePrice: item.precalculatedRefundableFareUpgradePrice,
            price: item.price,
            priceAsteriskVisibleClass: (data.isFullPriceConfigurationEnabled ? '' : 'hidden'),
            priceNextCtaEnabled: priceNextCtaEnabled,
            isChangeFlightFreeChargeValid,
            flightChangeFreeClass: this.getChangeFlightMessageClass(isChangeFlightFreeChargeValid),
            flightChangeEligibleClass: this.getChangeFlightMessageClass(isChangeFlightFreeChargeValid, true),
            pricePrefixStart: data.pricePrefixStart,
            priceSuffix: data.priceSuffix,
            priceTextLabel: data.priceTextLabel,
            totalPriceLabel: data.totalPriceLabel,
            priceWithoutDiscountPrice: formattedPriceTemplate(priceWithoutDiscountObj),
            expandableSlashedPrice: formattedPriceTemplate(expandableSlashedPriceObj),
            priceWithoutDiscounts: item.priceWithoutDiscounts,
            priceWithPrimeDiscount: item.priceWithPrimeDiscount,
            discount: formattedPriceTemplate(buildPriceObj({
                price: Math.abs(item.serviceFee),
                showPriceDecimals: false,
            }, '', data.currency)),
            mainPriceEqualProminence: formattedPriceTemplate(buildPriceObj({
                price: item.equalProminencePrimePrice / numPassengers,
                showPriceDecimals: data.showPriceDecimals,
            }, {prefix: 'odf-text-lg odf-strong',
                integer: 'odf-text-2xlplus odf-strong',
                decimal: 'odf-text-lg odf-strong',
                decimalSeparator: 'odf-text-lg odf-strong',
                suffix: 'odf-text-lg odf-strong',
            }, data.currency)),
            mainPriceEqualProminenceV2: formattedPriceTemplate(buildPriceObj({
                price: item.equalProminencePrimePrice / numPassengers,
                showPriceDecimals: data.showPriceDecimals,
            }, {prefix: 'odf-text-2lg odf-strong',
                integer: 'odf-text-2lg odf-strong',
                decimal: 'odf-text-2lg odf-strong',
                decimalSeparator: 'odf-text-2lg odf-strong',
                suffix: 'odf-text-2lg odf-strong',
            }, data.currency)),
            equalProminenceLabelMeta: equalProminenceLabelMetaText,
            nonDiscountedPriceEqualProminence: formattedPriceTemplate(buildPriceObj({
                price: ((item.equalProminenceNonPrimePrice) / numPassengers),
                showPriceDecimals: data.showPriceDecimals,
            }, {
                generic: 'odf-text-2lg odf-strong price_label',
            }, data.currency)),
            providerPrices: item.passengerFareTotals,
            searchId: data.searchId,
            searchType: data.searchType,
            seatsLeft: info.seatsLeft,
            shouldShowSlashedPrice: shouldShowSlashedPrice(
                options.isSlashedPricePartition,
                item.diffBetweenSlashedAndNormalPrice,
            ),
            showMembershipSubscriptionInfo: this.evaluateShowMembershipSubscriptionInfo(itemIndex, isMembershipDualPriceAbActive, data),
            showPriceDecimals: data.showPriceDecimals,
            showResultsPriceBreakDown: data.showResultsPriceBreakDown,
            slashedPrice,
            tests: options.tests,
            textWithoutDiscountDescription: data.textWithoutDiscountDescription,
            translations: Odigeo._.extend(Odigeo._.pick(data.translations, 'selectFlight'), options.translations),
            isResultsBoxRevampDesktop: Odigeo.AB.isResultsBoxRevampDesktop,
            isTrainCard: data.isTrainCard,
            dynpackSlashedPrice: dpPricePerPassengerWithoutDiscount,
            discountPercentage: dpDiscountPercentage,
            mainDynpackPrimePrice,
            isDynpackFullPrimePriceSelected: Odigeo.AB.isPrimeEnabled && data.isDynpackPriceWithoutDiscountSelected,
            differentialPricePerPassenger: differentialPricePerPax,
            totalPrice: tripTotalPrice,
            hasMetaBox: hasMetaBox,
        };
    },

    _fillSegItemWrapperTemplate(resultItemWrapperTemplate, itemIndex, item, data,
        itemPriceHtml, itemItinerariesHtml, itemResultPriceBreakDown, highlightedTag) {
        var itemHtml;
        var options = this.widget.options;
        var seatsLeft = seatsUtils.toItineraryTemplateData(Odigeo._.extend(item, {numPassengers: data.numPassengers}),
            Odigeo._.extend(options.translations, data.translations.seatsLeft),
            options);
        this.model.set('seatsLeft', seatsLeft);
        var membershipSubscriptionBubbleDescTxt = Odigeo.Utils.replaceCmsKeyArgs(data.membershipSubscriptionBubbleDescTxt,
            data.membershipSubscriptionPriceFmtd);
        if (item.odiRating.advantages.directAdvantage) {
            item.odiRating.advantages.durationAdvantage = false;
        }
        Odigeo.Session.set('membershipSubscriptionBubbleDescTxt', membershipSubscriptionBubbleDescTxt);
        this.model.isOdiRatingActive = this.model.isOdiRatingActive || highlightedTag === ODIRATING_TAG;
        item.numSeatsLeft = seatsLeft.num;

        var templateData = this.createTemplateDataFromItinerary(resultItemWrapperTemplate, itemIndex, item, data,
            itemPriceHtml, itemItinerariesHtml, itemResultPriceBreakDown, {
                seatsLeft: seatsLeft,
                membershipSubscriptionBubbleDescTxt: membershipSubscriptionBubbleDescTxt,
            }, highlightedTag);
        itemHtml = templatesUtils.template(resultItemWrapperTemplate)(templateData);
        return itemHtml;
    },

    getItemIndex(itemIndex) {
        if (this.widget.paginationType !== 'loadMore') {
            return itemIndex;
        }
        return this.model.calculateResultsOnPageDiff(0) + itemIndex;
    },

    _fillMetaResultHighlightedTemplate(resultFromMetaHighlighted, resultFromMetaTitle, $itemHighlighted) {
        $itemHighlighted = this._addHighlightToMetaResult($itemHighlighted);
        $itemHighlighted.prepend(this._fillMetaResultTitleTemplate(resultFromMetaTitle));
        return Odigeo._.template(resultFromMetaHighlighted)({itemHighlighted: $itemHighlighted.prop('outerHTML')});
    },

    _addHighlightToMetaResult($itemHighlighted) {
        return $itemHighlighted.removeClass('result_from_meta od-resultpage-wrapper')
            .addClass('resultpage_highlighted_meta')
            .toggleClass('od-resultpage-highlight', !Odigeo.SessionScope.isMetaFlights)
            .toggleClass('od-resultpage-highlight-new-ui', Odigeo.SessionScope.isMetaFlights)
            .attr('data-highlighted', true);
    },

    _fillMetaResultTitleTemplate(resultFromMetaTitle) {
        return templatesUtils.template(resultFromMetaTitle)();
    },

    reloadCreditCardSelector(ccJson) {
        var ccSelector = this.$cachedSelectors.creditCardSelector;
        var prevSelected = ccSelector.val();
        var docfrag2 = document.createDocumentFragment();
        var selected = '';

        ccSelector.find('option:gt(0)').remove();

        if (ccJson) {
            Odigeo._.each(ccJson, Odigeo._.bind(function(cc) {
                var name = cc.name;
                if (cc.method !== 'CREDITCARD') {
                    name = cc.name.toLowerCase();
                }
                if (String(cc.id) === String(prevSelected)) {
                    selected = ' selected';
                }
                if (cc.key === 'banktransfer.method') {
                    name = $('.credit_card_selector_container').data('label-banktransfer');
                }
                $('<option value="' + cc.id + '"' + selected + '>' + name + '</option>').appendTo(docfrag2);
            }, this));
        }
        ccSelector.append(docfrag2);
    },

    firstResultsFill(data) {
        var params;
        if (this.widget.pageBottomRequested === this.widget.pageBottomLoaded && this.widget.pageBottomLoaded === 0) {
            params = this.widget.model._getDataFirstResult(data);
            Odigeo.trigger(this.widget.id + ':firstResultsLoaded', params);
        }
    },

    adjustResults() {
        var widget = this.widget;
        var container = widget.view.$cachedSelectors.resultsContainerScrollable[0];
        var detailsTags = this.$widget.find('details');
        $.each(detailsTags, function() {
            var enhancedDetails = Odigeo.UIElements.enhanceExpandable(this, {selfClose: false});
            enhancedDetails.parent().find('.result_details_btn, .result_details_btn').off(Odigeo.Events.tap);
            enhancedDetails.parent().find('.result_details_btn, .hide_details_btn').on(Odigeo.Events.tap, Odigeo._.bind(function() {
                $(this).trigger('toggleExpandable');
            }, enhancedDetails));
        });

        this.$widget.find('.details_btn').on(Odigeo.Events.tap, Odigeo._.bind(function(e) {
            this.widget.execute('segmentDetailsHandler', e, this);
        }, this));

        Odigeo._.each(this.$cachedSelectors.bookingError, function(el) {
            Odigeo.UIElements.collapsive.enhance($(el));
        });

        // Credit card disclaimer
        widget.view.removeSelectorFromCache('results_default_disclaimer');
        widget.view.removeSelectorFromCache('results_selection_disclaimer');
        this.addSelectorToCache('results_default_disclaimer', this.$widget.find('.legal_text_default'));
        this.addSelectorToCache('results_selection_disclaimer', this.$widget.find('.legal_text_select'));

        var popupPrice = this.$widget.find('.popup_price_breakdown');
        Odigeo._.each(popupPrice, function(popup) {
            Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), popup, {
                events: {
                    tap: true,
                },
                googleAnalyticsOnOpen: {
                    type: 'trackEvent',
                    data: {
                        category: 'flights_results',
                        action: 'results_list',
                        label: 'open_fare_info',
                    },
                },
            });
        });

        var popUpInformation = this.$widget.find('.popUpInformation');
        Odigeo._.each(popUpInformation, function(popup) {
            Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), popup, {
                events: {
                    tap: true,
                },
                googleAnalyticsOnOpen: {
                    type: 'trackEvent',
                    data: {
                        category: 'flights_results',
                        action: 'results_list',
                        label: 'open_telephone_information',
                    },
                },
            });
        });

        var popupFlightDetails = this.$widget.find('.details_btn_desktop');
        Odigeo._.each(popupFlightDetails, function(popup) {
            Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), popup, {
                events: {
                    tap: true,
                },
                googleAnalyticsOnOpen: {
                    type: 'trackEvent',
                    data: {
                        category: 'flights_results',
                        action: 'results_list',
                        label: 'open_segment_info',
                    },
                },
                googleAnalyticsOnClose: {
                    type: 'trackEvent',
                    data: {
                        category: 'flights_results',
                        action: 'results_list',
                        label: 'closed_segment_info_top',
                    },
                },
                googleAnalyticsOnCloseButton: {
                    type: 'trackEvent',
                    data: {
                        category: 'flights_results',
                        action: 'results_list',
                        label: 'closed_segment_info_bottom',
                    },
                },
                trigger: 'results-manager:loadItineraryDetails',
            });
        });

        var charterDisclaimer = this.$widget.find('.charter_disclaimer');
        Odigeo._.each(charterDisclaimer, function(el) {
            Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), el, {
                events: {
                    tap: true,
                },
                trigger: 'results-manager:showCharterDisclaimer',
            });
        });

        var height = 0;
        var prevScroll = 0;
        while (container.childNodes.length > widget.maxLoadedPages) {
            // Remove the elements from the opposite side
            if (widget.model.delta === 1) {
                height = $(container.firstChild).outerHeight();
                this.$cachedSelectors.resultsContainer.trigger('getScrollTop');
                prevScroll = this.$cachedSelectors.resultsContainer.data('scrollTop');
                container.removeChild(container.firstChild);
                widget.pageTopLoaded++;
                widget.pageTopRequested++;
                Odigeo.trigger(this.widget.id + ':backToTop', {top: prevScroll - height});
            } else if (widget.model.delta === -1) {
                container.removeChild(container.lastChild);
                height = $(container.firstChild).outerHeight();
                widget.pageBottomLoaded--;
                widget.pageBottomRequested--;
                Odigeo.trigger(this.widget.id + ':backToTop', {top: height});
            } else {
                break;
            }
        }
        if (widget.paginationType !== 'loadMore') {
            $(container).children().first().removeClass('hidden');
        }
        // TODO do we need this data [widget.model.actualPage, widget.model.totalPages] , can it be in the widget
        Odigeo.trigger(this.widget.id + ':repaintPagination', [widget.model.actualPage, widget.model.totalPages]);
        this._updateHeigth();
    },

    updateResultsCount(filteredResultsCount, resultsCount) {
        var filteredResults = filteredResultsCount !== resultsCount;
        this.$cachedSelectors.numFilteredResults.html(filteredResultsCount);
        this.$cachedSelectors.numberOfResults.html(resultsCount);
        this.$cachedSelectors.filteredResultsMsg.toggleClass('odf-hidden', !filteredResults);
        this.$cachedSelectors.totalResultsMsg.toggleClass('odf-hidden', filteredResults);
    },

    loadResultsHandler(e) {
        e.preventDefault();
        // this.widget.model.delta = (e.type !== "reachedstart") ? 1 : -1;
        this.loadResults((e.type !== 'reachedstart') ? 1 : -1, true);
    },

    loadResults(page, isDelta) {
        var widget = this.widget;
        var pageLoad = !Odigeo._.isUndefined(page);
        var pageToLoad = page || 1;
        var delta = isDelta ? page : 1;

        switch (this.widget.paginationType) {
            case 'loadMore':
                var moreResultsBottom;
                var moreResultsTop;

                this.widget.model.delta = delta;

                if (widget.pageBottomLoaded > widget.pageBottomRequested) {
                    widget.pageBottomLoaded = widget.pageBottomRequested;
                }
                if (widget.pageTopLoaded > widget.pageTopRequested) {
                    widget.pageTopLoaded = widget.pageTopRequested;
                }
                moreResultsBottom = (widget.pageBottomLoaded * widget.resultsByPage - 1) < widget.model.numberOfFilteredResults;
                moreResultsTop = !(widget.pageTopLoaded === 1 && delta === -1);

                Odigeo.trigger(this.widget.id + ':toggleNoMoreResults', moreResultsBottom);
                if (delta === 1) {
                    if (!moreResultsBottom) {
                        return;
                    } else {
                        Odigeo.trigger(this.widget.id + ':toggleLoader', false);
                        widget.pageBottomRequested++;
                    }
                } else if (delta === -1) {
                    if (!moreResultsTop) {
                        return;
                    } else {
                        if (widget.backToTop) {
                            widget.pageBottomRequested = 1;
                            widget.pageBottomLoaded = 1;
                            widget.pageTopRequested = 1;
                            widget.pageTopLoaded = 1;
                            widget.backToTop = false;
                        } else {
                            widget.pageTopRequested--;
                        }
                    }
                }
                widget.pageToLoad = delta === -1 ? widget.pageTopRequested : widget.pageBottomRequested;
                break;
            case 'nPagesSet':
            case 'blockPagesSet':
                widget.pageToLoad = isDelta ? widget.model.actualPage + pageToLoad : pageToLoad;
                if (pageLoad) {
                    this.$cachedSelectors.resultsLoader.removeClass('hidden');
                    this.$cachedSelectors.resultsContainer.addClass('invisible');
                }
                break;
        }
        Odigeo.trigger(this.widget.id + ':togglePaginationContainer', true);

        if (this.model.get('allowedRefresh')) {
            widget.model.refresh();
        }
    },

    bookBtnPositionHandler(params) {
        var $bookBtns = this.$widget.find('.book_btn_container');
        if (params.action === 'filter' && !$bookBtns.hasClass('filters')) {
            $bookBtns.toggleClass('filters', params.filters).toggleClass('multi', params.multi);
        } else if (params.action === 'reset') {
            $bookBtns.removeClass('filters').removeClass('multi');
        }
    },

    setClass(params) {
        this.$cachedSelectors[params.selector].addClass(params.cls);
    },

    trackMembershipPriceSelected(isDiscountSelected) {
        var membershipTrackLabel = isDiscountSelected ? 'subscription_price_selected' : 'nonmember_price_selected';
        this.widget.trackMembership(membershipTrackLabel);
    },

    changePriceDiscountSelected($resultContainer, isDiscountSelected) {
        $resultContainer.attr('data-is-price-without-discount-selected', !isDiscountSelected);
    },

    changePriceDiscountRadio(e) {
        var isDiscountSelected = e.currentTarget.value !== 'true';
        var $radioElement = $(e.currentTarget);
        this.trackMembershipPriceSelected(isDiscountSelected);
        this.changePriceDiscountSelected($(e.target).parents('.result'), isDiscountSelected);
        if ($radioElement.parent().hasClass('error')) {
            this.widget.view.resetRadioButtons($radioElement.parents('.itinerary_header'));
        }
    },

    monitorFilterButtonVisibility($button) {
        var throttleDelay = 100;
        var $window = $(window);
        var buttonStart = $button.offset().top;
        var windowHeight = window.innerHeight ? window.innerHeight : $window.height();
        var thresholdStart = buttonStart - windowHeight;
        var thresholdEnd = buttonStart + $button.height() + this._filtersButtonMeasures.height +
            this._filtersButtonMeasures.bottom * 2 - windowHeight;

        this.checkIfFiltersButtonNeedsToBeHidden(thresholdStart, thresholdEnd, $window);

        // the following 4 lines are needed to "cancel" the throttled functions that are queued with "old" data.
        this._disableChecking = true;
        window.setTimeout(Odigeo._.bind(function() {
            this._disableChecking = false;
        }, this), throttleDelay);

        var ev = 'scroll.' + this.widget.id + ':filterMonitoring';
        $window.off(ev).on(ev, Odigeo._.throttle(
            Odigeo._.bind(function() {
                if (!this._disableChecking) {
                    this.checkIfFiltersButtonNeedsToBeHidden(thresholdStart, thresholdEnd, $window);
                }
            }, this),
            throttleDelay));

        ev = 'resize.' + this.widget.id + ':filterMonitoring';
        $window.off(ev).on(ev, Odigeo._.bind(this.monitorFilterButtonVisibility, this, $button));
    },

    checkIfFiltersButtonNeedsToBeHidden(start, end, $window) {
        var scrollPos = $window.scrollTop();

        if (scrollPos > start && scrollPos < end) {
            if (!this._filterButtonHidden) {
                Odigeo.trigger(this.widget.id + ':slideButton', true);
                this._filterButtonHidden = true;
            }
        } else if (this._filterButtonHidden) {
            Odigeo.trigger(this.widget.id + ':slideButton', false);
            this._filterButtonHidden = false;
        }
    },

    setFiltersButtonMeasures(measures) {
        this._filtersButtonMeasures = measures;
    },

    priceAlertBannerHasToBeShown(itemIndex) {
        return itemIndex === 1 && Odigeo.SessionScope.flow === 'desktop';
    },

    membershipBubbleHasToBeShown(itemIndex) {
        return !isDynpack && Odigeo.SessionScope.flow === 'desktop'
            && (itemIndex === 1 || (itemIndex === 3 && Odigeo.Membership.isMembershipProductEnabledDesktop));
    },

    showPriceAlertBanner(targetElem) {
        const widgetId = 'price-alerts-banner';
        targetElem.append($('<div>', {id: widgetId}));
        Odigeo.trigger(widgetId + ':onPriceAlertBannerContainerInserted');
    },

    getPromotedItineraryTypes(bookingData) {
        let promotedItineraryTypes = [];
        if (bookingData.selectedItinerary.odiRating.highlightedTag === ODIRATING_TAG) {
            promotedItineraryTypes.push('ODI_RATING');
        }
        if (bookingData.returningUserDeviceId) {
            promotedItineraryTypes.push('PERSONALIZED');
        }
        return promotedItineraryTypes;
    },

    buildPriceObj: buildPriceObj,
    continueBooking: continueBooking,
    getItineraryInfo: getItineraryInfo,
    getBookingData: getBookingData,
};
